import config from '@/config'
import axios from 'axios'
import nl2br from 'vue-nl2br'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { mapGetters } from 'vuex'

import { bearhousecalculateshippingprice } from '@/assets/js/BearHouse.js'
import { shippingprice as cdsshippingprice } from '@/assets/js/Cds.js'
import {
  foodguruCalShippingPrice,
  foodguruShippingRate
} from '@/assets/js/Foodguru.js'
import BankNumber from '@/components/BankNumber.vue'
import Cover from '@/components/Cover.vue'
import DatePicker from '@/components/DatePicker.vue'
import DatepickerCustomDialog from '@/components/DatepickerCustomDialog.vue'
import CartSummary from '@/components/ecommerce/CartSummary.vue'
import EditCartSummary from '@/components/ecommerce/EditCartSummary.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import ShippingType from '@/components/ecommerce/ShippingType.vue'
import TermAndCondition from '@/components/ecommerce/TermAndCondition.vue'
import Loading from '@/components/Loading.vue'
import Modal from '@/components/Modal.vue'
import CartItem from '@/components/payment/CartItem.vue'
import UploadFile from '@/components/UploadFile.vue'
import moment from 'moment'
// import querystring from "querystring";
import numeral from 'numeral'
import { mask } from 'vue-the-mask'

import NativeSelect from '@/components/NativeSelect.vue'
import ThaiAddressInput from '@/components/ThaiAddressInput'

import GmapAddress from '@/components/ecommerce/GmapAddress2.vue'
import VoucherCodeInput from '@/components/ecommerce/VoucherCodeInput'
import VueOtpBox from 'vue-otp-box'
import 'vue-otp-box/dist/VueOtpBox.css'

import { bundleApi } from '@/api/bundles.js'
import { paymentGatewayApi } from '@/api/payment-gateway.js'
import DefaultPaymentButton from '@/components/ecommerce/Payment/DefaultPaymentButton.vue'
import { PAGE_SCG_LIVE } from '@/config/page'
import { getFuzePostZone } from '@/custom/cityfresh'
import paymentMixin from '@/mixins/paymentMixin.js'
import * as Sentry from '@sentry/vue'
import Omise from './Omise/mixins'
import Payment from './Payment/index.vue'

const dict = {
  en: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'Wrong shipping address'
      },
      paymentSlipImage: {
        required: 'Payment slip image required'
      }
    }
  },
  th: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'ที่อยู่จัดส่งไม่ถูกต้อง'
      },
      paymentSlipImage: {
        required: 'กรุณาแนบใบเสร็จโอนเงิน'
      }
    }
  },
  la: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'ที่อยู่จัดส่งไม่ถูกต้อง'
      },
      paymentSlipImage: {
        required: 'กรุณาแนบใบเสร็จโอนเงิน'
      }
    }
  }
}

export default {
  directives: { themask: mask },
  mixins: [paymentMixin, Omise],
  data() {
    return {
      verifyData: null,
      verifyDataEditPage: null,
      fixDiscount: null,
      isVoucherCode: true,
      product_detail_json: null,
      paymentLoading: false,
      shopName: null,
      remotePostcode: null,
      transport_lists: [],
      weight: 0,
      quantityType: 0,
      setShopOption: false,
      exceptCashOnDelivery: false,
      shopOption: [],

      //salePage
      salePage: null,
      hasCartarray: false,
      //taxInvoice
      tax_id: '',
      tax_name: '',
      taxAddress: null,
      dialogtaxInvoice: false,
      //egg
      refOtp: null,
      dialogOtp: false,
      submitCheckbox: false,
      dialogPrivacyNotice: false,
      dialogTermAndCondition: false,
      privacy_notice: null,
      term_and_condition: null,
      notShipping: false,
      notReachMinimum: false,
      minimumPrice: 0,
      isAddPoints: false,
      isNotRegisterEgg: false,
      dailogAddpoints: false,
      memberPhoneNumber: null,
      //
      countDown: 0,
      timeOutCount: null,
      successDialog: false,

      allproducts: [],
      monobobanklist: [
        // { text: "ธนาคารกรุงเทพ", value: "กรุงเทพ" },
        // { text: "ธนาคารที.เอ็ม.บี (ทหารไทย)", value: "ที.เอ็ม.บี (ทหารไทย)" },
        // { text: "ธนาคารไทยพาณิชย์", value: "ไทยพาณิชย์" },
        // { text: "ธนาคารกสิกรไทย", value: "กสิกรไทย" },
        // { text: "ธนาคารยูโอบี", value: "ยูโอบี" },
        { text: 'ธนาคารออมสิน', value: 'ออมสิน' }
      ],
      facebookname: '',
      encodedfacebookname: '',
      amount: '',
      creditcard: {
        name: '',
        number: '',
        validate: '',
        expiremonth: '',
        expireyear: '',
        cvv: ''
      },
      orderid: '',
      gbprime: {
        url: null,
        token: null,
        refno: null,
        backgroundUrl: null,
        amount: null
      },
      timestamp: moment().format('x'),
      app: 'facebook',
      pageid: null,
      userid: null,
      paiddate: null,
      paidtime: null,
      products: {},
      remark: '',
      transferType: '',

      additionalproduct_charge: 0,
      ems_charge: 0,
      normal_charge: 0,
      kerry_charge: 0,
      total: 0,
      totalincludediscount: 0,
      discount: 0,

      shippingType: {
        type: null,
        value: 0
      },

      loading: false,
      fetchLoading: true,

      isCompleted: false,
      isCompletePayment: false,
      isEmptyShoppingCart: false,

      shippingAddress: null,
      showAlert: false,
      showProduct: false,
      shippinglist: undefined,
      showQrCode: false,
      qrimage: '',
      intervalQrCode: null,
      timer: 300,
      isRequest: true,
      referenceNo: '',

      config: {
        color: config.color
      },

      sessiontoken: null,
      // banktransferinfo: null,
      // banktransferinfo_photo: null,
      paymentSlipImage: null,

      email: null,
      showTerm: false,
      customerName: null,
      customerPhone: null,
      loadingQrcode: false,
      isCartOutOfStock: false,
      bankname: 'ออมสิน',
      isPaypal: false,
      paypal_merchantid: null,

      shippingAddress2: {
        address: '',
        zipcode: '',
        province: '',
        district: '',
        sub_district: ''
      },
      useOldAddress: [
        '485851741439218', // ยงยู่กี่
        '1937813489833600', // shouwa88
        '111268274484483', // Russian
        '1659123844317222', // แชมพูสมุนไพรอาบน้ำสุนัขซีโนน่า
        // '118209918234524', //  หนุ่มเมืองจันท์
        '106757434745524', // shāta
        '104255358794903', // ตาดูดาว หนังสือประวัติทักษิณ ชินวัตร
        '1122943801057329',
        '105201378805626', //Wynn Farm Veggie
        '100203512915939',
        '111151505282962'
      ],
      // allowtransfer: false,
      allowcreditcard: false,
      isEditAddress: false,
      loadingVoucher: true,
      voucher: null,
      voucherCode: null,
      hasVoucher: false,
      gbpath: 'https://api.gbprimepay.com',
      gbcharge: null,
      gbpublickey: '',

      hasShippingNow: false,
      hasOtherProduct: false,
      chooseShippingType: 'delivery',
      showmap: false,
      placesinfolabel: null,
      gmapvalue: null,
      shoplocation: null,
      shippingcostdistance: null,
      pickupdate: null,
      mindate: moment().format('YYYY-MM-DD HH:mm'),
      maxdate: moment().add(7, 'days').format('YYYY-MM-DD HH:mm'),
      // alice
      isAutoPacking: false,

      isBorrowPan: false,
      borrowPanInfo: {
        isaccept: null,
        age: null,
        name: null,
        idcard: null
      },
      loadingLastlocation: true,
      payment_slip_status: false,
      transport_code: null,
      transport_cost: null,
      weightAll: 0,
      lastordercoords: null,
      foodguruDistance: null,
      ableToShipping: true,
      foodguruDeliveryPrice: 0,
      externalScript: null,
      loadingMap: true,
      deliveryOption: [],
      lalamove: {
        result: null,
        fee: 0,
        shop_fee: 0,
        cod: false
      },
      loadingMapInfo: true,
      loadingLalamove: false,
      reference: null,
      inputNestle: {
        email: ''
      },
      inputCityFresh: {
        booking_date: '',
        booking_time: ''
      },
      selectedGiveAwayProduct: null,
      qrcodeInterval: null,
      gbFormData: {
        public_key: '',
        secret_key: '',
        amount: '',
        referenceNo: '',
        bankCode: '004',
        responseUrl: document.location.href,
        backgroundUrl: `${config.getConfig('serverUrl')}gbprimebackendresult`,
        hash: ''
      },
      gbBank: [
        { text: 'kBank', value: '004' },
        { text: 'SCB', value: '014' },
        { text: 'Krungsri', value: '025' },
        { text: 'BBL', value: '002' },
        { text: 'Krungthai', value: '006' }
      ],
      showAddressManage: false,
      shippingAddressList: [],
      shippingFormType: 'add',
      selectedAddress: null,
      selectedEditAddress: null,
      rtrCode: '',
      address_lat: null,
      address_long: null
    }
  },
  created() {
    this.hasCartarray = localStorage.getItem('cartarray') !== null
  },
  mounted: async function () {
    let vm = this

    vm.$validator.localize(dict)
    vm.$validator.localize(vm.currentLang)
    if (vm.pageProfile.egg_crm_status) {
      vm.getPrivacyNoticeEgg()
      vm.getTermAndConditionEgg()
    }
    if (vm.pageProfile.shop_addon_form_json) {
      vm.shopOption = JSON.parse(vm.pageProfile.shop_addon_form_json)
      vm.setShopOption = vm.pageProfile.shop_addon_form_status
    }

    vm.loading = true
    vm.loadingVoucher = true

    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid
    }

    if (vm.$route.query.pkey) {
      vm.omise_key = vm.$route.query.pkey
    }

    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken
    }

    if (vm.$route.query.ref) {
      vm.reference = vm.$route.query.ref
    }

    vm.fetchLoading = true

    if (config.env == 'shopcommu') {
      await vm.loadCheckBranch(vm.pagename)
    }

    vm.pageid = vm.pageProfile.pageid
    if (vm.getSalePage) {
      vm.salePage = vm.getSalePage
    } else {
      if (vm.pageProfile.has_sale_page)
        vm.$store.dispatch('getSalePage', vm.pageid)
    }

    vm.allowcreditcard =
      vm.pageProfile.allowcreditcard == 'true' ||
      vm.pageProfile.allowcreditcard === true
        ? true
        : false

    document.title = vm.pageProfile.pagename
    vm.$store.dispatch('updateShopColor', vm.pageProfile.shopcolor)
    vm.fetchLoading = false
    vm.gbpublickey = vm.pageProfile.gbprime_publickey

    vm.hasVoucher = vm.pageProfile.ispromocode

    if (config.env == 'shop') await vm.getShippingcostdistance()
    else if (config.env == 'shopcommu') {
      if (vm.pageProfile.type == 'cityfresh') {
        vm.deliveryOption.push('delivery')
        vm.deliveryOption.push('lalamove')

        vm.chooseShippingType = 'delivery'
        let id = Math.floor(Math.random() * 1000000000)
        vm.branchlocation = [
          {
            lat_long: '13.648745584110296,100.40763640481279',
            name: 'City Fresh',
            pictureurl:
              'https://zwizai.s3.amazonaws.com/ecommerce/1653641182951275855152_5033944150024176_5037063965862073180_n.jpg'
          }
        ]
        vm.shippingcostdistance = {
          shoplocation: [
            {
              name: 'City Fresh',
              lat_long: '13.648745584110296,100.40763640481279',
              pictureurl:
                'https://zwizai.s3.amazonaws.com/ecommerce/1653641182951275855152_5033944150024176_5037063965862073180_n.jpg',
              distance: [],
              optionType1: [],
              optionType2: [],
              termsOption: [],
              id: id,
              lalamoveFee: '0'
            }
          ]
        }
        vm.shoplocation = vm.shippingcostdistance.shoplocation
        vm.googleapikey = 'AIzaSyAUjz9U1V6X6LvNDTi09AH7VWksT2xplmM'
        vm.getbranchlocation()
      }

      if (vm.pageProfile.type == 'tremendous') {
        vm.googleapikey = 'AIzaSyBfmE_-YMIGBHwHkq7omK0xW4reB-rBIzE'
        vm.getbranchlocation()
        vm.getShippingAddressList()
      }

      vm.handleGetPaymentGateway()
    }

    if (!vm.deliveryOption || !vm.deliveryOption.includes('map')) {
      vm.loadingMapInfo = false
    }

    // await vm.checkpageusepromocode();

    if (vm.$route.query.app) {
      vm.app = vm.$route.query.app
    }

    if (vm.userid) {
      try {
        let firstletterofuserid = vm.userid.charAt(0)
        if (
          firstletterofuserid &&
          (firstletterofuserid.toLowerCase() == 'u' ||
            firstletterofuserid.toLowerCase() == 'l')
        ) {
          vm.app = 'line'
        }
        if (
          vm.userid.split('__').length === 2 &&
          vm.userid.charAt(0).toLowerCase() !== 'u'
        ) {
          vm.app = 'instagram'
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }

      // var response_lang = await vm.$store.dispatch("getUserShopLang", {
      //   pageid: vm.pageProfile.pageid,
      //   userid: vm.userid,
      // });
      // vm.facebookname = response_lang.facebookname;
      // if (response_lang) {
      //   vm.$store.dispatch("setLang", response_lang.usershoplang);
      // }
      vm.facebookname = vm.pageProfile.pagename
      vm.$store.dispatch('setLang', vm.pageProfile.shoplang)
      var userdata = await vm.getUserDetail()
      let tmpaddress = null
      try {
        tmpaddress = localStorage.getItem('tmpaddress')
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
        return
      }

      if (
        userdata &&
        (userdata.address || userdata.email || userdata.name || userdata.phone)
      ) {
        vm.customerName = userdata.name
        vm.customerPhone = userdata.phone
        if (vm.pageProfile.type == 'nestle') {
          vm.inputNestle.email = userdata.email || ''
        }
        if (vm.pageProfile.type == 'yasale') {
          vm.remark = userdata.remark || ''
        }
        try {
          if (vm.shopOption && vm.shopOption.length > 0)
            vm.shopOption[2].message = userdata.email
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
          return
        }
        if (vm.pageProfile.type == 'bec') {
          vm.inputBec.email = userdata.email ? userdata.email : ''
        }
        var shippingaddress = userdata.address
          ? userdata.address.split(',')
          : []
        if (shippingaddress.length > 0) {
          shippingaddress = shippingaddress.map((el) => {
            return el.trim()
          })
        }
        if (
          shippingaddress.length >= 5 &&
          !vm.useOldAddress.includes(vm.pageProfile.pageid)
        ) {
          var postcode_index = shippingaddress.findIndex((el) => {
            return el.match(/^[\d]{5}/g)
          })
          if (postcode_index != -1) {
            vm.shippingAddress2.zipcode = shippingaddress[postcode_index]
            shippingaddress.splice(postcode_index, 1)
          }

          var province_index = shippingaddress.findIndex((el) => {
            return el.match(/^จังหวัด[aA-zZก-๛]+/g)
          })

          if (province_index != -1) {
            vm.shippingAddress2.province = vm.replaceAddress(
              shippingaddress[province_index]
            )
            shippingaddress.splice(province_index, 1)
          } else if (shippingaddress.length >= 4) {
            vm.shippingAddress2.province = vm.replaceAddress(
              shippingaddress.pop()
            )
          }

          var district_index = shippingaddress.findIndex((el) => {
            return el.match(/^อำเภอ[aA-zZก-๛]+/g)
          })
          if (district_index != -1) {
            vm.shippingAddress2.district = vm.replaceAddress(
              shippingaddress[district_index]
            )
            shippingaddress.splice(district_index, 1)
          } else if (shippingaddress.length >= 3) {
            vm.shippingAddress2.district = vm.replaceAddress(
              shippingaddress.pop()
            )
          }

          var sub_district_index = shippingaddress.findIndex((el) => {
            return el.match(/^ตำบล[aA-zZก-๛]+/g)
          })
          if (sub_district_index != -1) {
            vm.shippingAddress2.sub_district = vm.replaceAddress(
              shippingaddress[sub_district_index]
            )
            shippingaddress.splice(sub_district_index, 1)
          } else if (shippingaddress.length >= 2) {
            vm.shippingAddress2.sub_district = vm.replaceAddress(
              shippingaddress.pop()
            )
          }
          vm.shippingAddress = shippingaddress.join(' ')
        } else {
          vm.shippingAddress = userdata.address
        }
      } else if (tmpaddress) {
        try {
          tmpaddress = JSON.parse(tmpaddress)
          let data = tmpaddress.find((el) => {
            return el.userid == vm.userid
          })
          if (data) {
            vm.customerName = data.name ? data.name : ''
            vm.customerPhone = data.phone ? data.phone : ''
            vm.shippingAddress = data.addresno ? data.addresno : ''
            if (vm.shopOption && vm.shopOption.length > 0)
              vm.shopOption[2].message = data.email ? data.email : ''
            if (data.address) {
              vm.shippingAddress2 = data.address
            }
          }
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
          return
        }
      }

      // vm.remark = vm.pageProfile.type == "monobo" && userdata.remark && userdata.remark != null ? userdata.remark.split(";;")[0] : "";
    }

    if (['nestle'].includes(vm.pageProfile.type)) {
      try {
        const response = await bundleApi.getAllBundles({
          data: {
            pageid: vm.pageProfile.pageid,
            limit: 9999,
            offset: 0
          }
        })
        let product_bundle = []
        if (response.data.product_bundle) {
          product_bundle = response.data.product_bundle.map((bundle) => {
            return {
              ...bundle,
              products: bundle.products.map((product) => {
                const photourl = product.photourl
                  ? product.photourl.split(';;')
                  : []
                return { ...product, photourl }
              }, [])
            }
          })
        }
        vm.$store.commit('bundles/SET_BUNDLES', product_bundle)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }

      try {
        const response = await bundleApi.calculateBundle({
          data: {
            pageid: vm.pageProfile.pageid,
            userid: vm.userid
          }
        })

        const { nestle_discount_bundle = 0, nestle_bundle_id = null } =
          response.data

        vm.$store.commit('bundles/SET_BUNDLE_DISCOUNT', {
          nestle_discount_bundle,
          nestle_bundle_id
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }

    if (vm.pageProfile && vm.pageProfile.wholesale_status === true) {
      // vm.$store.dispatch("getWholeSaleStatus", vm.pageProfile.pageid).then(function() {
      vm.$store.dispatch('getWholeSale', vm.pageProfile.pageid)
      // });
    }

    if (vm.pageProfile) {
      vm.payment_slip_status = vm.pageProfile.payment_slip_status
      try {
        let useragent = navigator.userAgent || navigator.vendor || window.opera

        if (vm.userid) {
          let split_userid = vm.userid.split('__')
          if (split_userid.length === 2) {
            if (vm.userid.startsWith('U') || vm.userid.startsWith('LU')) {
              useragent = 'line'
            }
          }
        }

        if (useragent.toLowerCase().includes('line')) {
          vm.payment_slip_status = false
        }
      } catch (error) {
        vm.payment_slip_status = false
        // console.error(error);
      }
    }

    if (vm.pageProfile && vm.pageProfile.theme === 'runkan') {
      await vm.getRunkanProfileData()
    }

    if (vm.pageProfile && vm.pageProfile.type === 'foodguru') {
      await vm.getFoodgurubranchlocation()
    }

    // if(!["bec"].includes(vm.pageProfile.theme)) {
    await vm.getUserCart(vm.pageProfile.shippinglist)
    // } else {
    //   console.log("pageProfile: ",vm.pageProfile)
    //   console.log("cart: ",vm.cart)
    //   console.log("shippinglist: ",vm.shippinglist)
    // }

    if (vm.pageProfile && vm.pageProfile.type == 'alice') {
      // eslint-disable-next-line no-undef
      let shippinglist = _.cloneDeep(vm.shippinglist)
      let chiffon = vm.cart.filter((p) => {
        return ['23502'].includes(p.categoryid.toString())
      })
      let browny = vm.cart.filter((p) => {
        return ['23498'].includes(p.categoryid.toString())
      })

      if (shippinglist) {
        for (const key in shippinglist) {
          if (Object.hasOwnProperty.call(shippinglist, key)) {
            if (
              key == 'other_charge' &&
              (chiffon.length > 0 || (chiffon.length > 0 && browny.length > 0))
            ) {
              // สินค้าจัดส่งรถควบคุมอุณหภูมิ
              shippinglist[key][1] = true
            } else if (
              key == 'ems_charge' &&
              browny.length > 0 &&
              chiffon.length == 0
            ) {
              // สินค้าจัดส่ง Ems
              shippinglist[key][1] = true
            } else {
              shippinglist[key][1] = false
            }
          }
        }
      }

      vm.shippinglist = shippinglist
      vm.shippingType = shippinglist[0]
      vm.timestamp = moment().format('x')
    }

    // await vm.getTransferDetail();
    if (vm.pageProfile.paypal_merchantid) {
      vm.isPaypal = true
    }

    if (vm.isPaypal) {
      // vm.renderPaypalBtn();
    }
    var isCartOutOfStock = vm.cart.filter(function (el) {
      // console.log(el.remainingquantity,el.quantity,parseInt(el.remainingquantity),  parseInt(el.quantity));
      if (el.adjust_qty && el.adjust_qty >= el.quantity) {
        return false
      } else {
        return parseInt(el.remainingquantity) < parseInt(el.quantity)
      }
    })

    vm.isCartOutOfStock = isCartOutOfStock.length > 0

    if (
      !vm.userid &&
      vm.hasCartarray &&
      vm.getSalePage &&
      vm.getSalePage.is_active
    ) {
      vm.isCartOutOfStock = false
    }

    if (PAGE_SCG_LIVE.includes(vm.pageProfile.pageid)) {
      vm.isCartOutOfStock = false
    }

    vm.setTransferDefault()
    vm.setShippingDefault()

    if (vm.isCartOutOfStock) {
      const result = await vm.$swal({
        title: vm.$t('Not enough products in stock'),
        text: vm.$t('Please try to order again or contact Admin'),
        type: 'warning',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('Cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let url = '/ecommerce/' + vm.pagename
        if (vm.userid && vm.userid != null && vm.userid != '') {
          url += '?userid=' + vm.userid
          if (
            vm.sessiontoken &&
            vm.sessiontoken != null &&
            vm.sessiontoken != ''
          ) {
            url += '&sessiontoken=' + vm.sessiontoken
          }
        }
        vm.$router.push({ path: `${url}&modalOpen=true` })
      }
      if (vm.$liff.isInClient()) {
        // eslint-disable-next-line no-undef
        await vm.$liff.sendMessages([
          {
            type: 'text',
            text:
              vm.$t('Not enough products in stock') +
              ', ' +
              vm.$t('Please try to order again or contact Admin')
          }
        ])
        // eslint-disable-next-line no-undef
        // await vm.$liff.closeWindow();
      }
    }
    if (
      ['112085313900804', '10242104823979', '105928254552462'].includes(
        vm.pageProfile.pageid
      )
    ) {
      await vm.testCentral2c2p()
    }
    await vm.callafter()

    if (vm.pageProfile) {
      if (vm.pageProfile.type == 'alice') {
        try {
          vm.mindate = vm.getMindate()
        } catch (error) {
          //
        }
        let onlyToday = vm.cart.filter((el) => {
          return ['23506'].includes(el.categoryid.toString())
        })
        let browny = vm.cart.filter((el) => {
          return ['23498'].includes(el.categoryid.toString())
        })
        let chiffon = vm.cart.filter((el) => {
          return ['23502'].includes(el.categoryid.toString())
        })
        let notEmsAndFreeze = vm.cart.filter((el) => {
          return !['23498', '23502'].includes(el.categoryid.toString())
        })

        if (onlyToday && onlyToday.length > 0) {
          vm.maxdate = moment().format('YYYY-MM-DD 23:59')
        } else if (!notEmsAndFreeze) {
          vm.maxdate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm')
        }
        // 25480 จองขนมสาทรจีน
        let จองขนมสาทรจีน = vm.cart.filter((p) => {
          return ['25480', '26372'].includes(p.categoryid.toString())
        })

        if (vm.deliveryOption) {
          let deliveryOption
          deliveryOption = vm.deliveryOption.filter((el) => {
            if (จองขนมสาทรจีน.length > 0) {
              return el == 'pickup'
            } else if (notEmsAndFreeze.length > 0) {
              if (el == 'map' || el == 'pickup') {
                return true
              } else {
                return false
              }
            } else {
              if (browny.length > 0 || chiffon.length > 0) {
                if (el == 'delivery') return true
                else return false
              }
            }
            return true
          })
          vm.deliveryOption = deliveryOption
          vm.selectShippingType(vm.deliveryOption[0])
        }

        // "ขนม-บราวนี และ คุกกี้" ems;
        // "ขนม-ชิฟฟอนเค้ก และ อื่นๆ" คุมอุณหภูมิ;
      } else if (vm.pageProfile.type == 'lukkaithong') {
        //
        // 24992,50264 "👉เมนูส่งเดลิเวอรี่";
        // 24993,50265 "👉เมนูส่งทั่วไทย 77 จังหวัด"

        let upcountry = vm.cart.filter((el) => {
          return ['24993', '50265'].includes(el.categoryid.toString())
        })
        let urban = vm.cart.filter((el) => {
          return ['24992', '50264'].includes(el.categoryid.toString())
        })

        if (vm.deliveryOption) {
          let deliveryOption
          deliveryOption = vm.deliveryOption.filter((el) => {
            if (urban && urban.length > 0) {
              if (el == 'map') {
                return true
              } else {
                return false
              }
            } else if (upcountry && upcountry.length > 0) {
              if (el == 'delivery') return true
              else return false
            }

            return true
          })
          vm.deliveryOption = deliveryOption
          vm.selectShippingType(vm.deliveryOption[0])
        }
      }
    }

    var gmapregex =
      // eslint-disable-next-line no-useless-escape
      /https\:\/\/www\.google\.com\/maps\?q\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
    if (vm.deliveryOption) {
      if (vm.deliveryOption.includes('map')) {
        vm.chooseShippingType = 'map'
      } else if (vm.deliveryOption.includes('lalamove')) {
        vm.chooseShippingType = 'lalamove'
      }
    }

    try {
      if (vm.shippingAddress && vm.shippingAddress.match(gmapregex)) {
        // eslint-disable-next-line no-useless-escape
        let regex = /\?q\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
        let google_link = vm.shippingAddress.match(regex)

        if (google_link && google_link.length > 0) {
          google_link = google_link[0]
          google_link = google_link.replaceAll('?q=', '')
          google_link = google_link.split(',')
          vm.gmapvalue = {
            lat: parseFloat(google_link[0]),
            lng: parseFloat(google_link[1])
          }
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      //
    }

    try {
      if (vm.shippingAddress && vm.shippingAddress.match(gmapregex)) {
        vm.shippingAddress = vm.shippingAddress
          .replace(gmapregex, '')
          .replace('\n', '')
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }

    await vm.$nextTick()
    vm.loadingLastlocation = false
    if (
      ['324885161495477', '103195847822433'].includes(vm.pageProfile.pageid) &&
      vm.total < 500
    ) {
      vm.minimumPrice = 500
      vm.notReachMinimum = true
    }
    if (['108209024822196'].includes(vm.pageProfile.pageid) && vm.total < 100) {
      vm.minimumPrice = 100
      vm.notReachMinimum = true
    }

    vm.loadingVoucher = false
    vm.loading = false
  },
  components: {
    VueOtpBox,
    SyncLoader,
    Loading,
    Modal,
    Cover,
    MerchantDetail,
    nl2br,
    UploadFile,
    TermAndCondition,
    CartItem,
    BankNumber,
    ShippingType,
    CartSummary,
    EditCartSummary,
    NativeSelect,
    ThaiAddressInput,
    VoucherCodeInput,
    GmapAddress,
    DatePicker,
    DatepickerCustomDialog,
    DefaultPaymentButton,
    Payment
  },
  computed: {
    hashGbForm() {
      return 'test'
    },
    mainConfig() {
      return config
    },
    isNestle() {
      return this.pageProfile && ['nestle'].includes(this.pageProfile.type)
    },
    isSeagull() {
      return this.pageProfile && ['seagull'].includes(this.pageProfile.theme)
    },
    isTremendous() {
      return this.pageProfile && this.pageProfile.type === 'tremendous'
    },
    serverUrl() {
      if (
        this.pageProfile.pageid == '115414076948160' ||
        this.pageProfile.pageid == '396306053873110'
      ) {
        return config.thailandpostmart.serverUrl
      } else {
        return config.getConfig('serverUrl')
      }
    },
    pageLoading() {
      return (
        this.fetchLoading ||
        (this.deliveryOption &&
          (this.deliveryOption.includes('map') ||
            this.deliveryOption.includes('lalamove')) &&
          this.loadingMap)
      )
    },
    allowtransfer() {
      return this.pageProfile && this.pageProfile.allowtransfer
    },
    banktransferinfo() {
      return this.pageProfile && this.pageProfile.banktransferinfo
        ? this.pageProfile.banktransferinfo
        : null
    },
    isTremendousPledgeWaterTank() {
      if (this.isTremendous) {
        const tempCart = this.cart
        if (tempCart && tempCart.length > 0) {
          const findPledgeWaterTankProduct = tempCart.findIndex(
            (item) =>
              item.name === 'มัดจำถังน้ำ 18.9 ลิตร 1ถัง/100บาท' ||
              item.name === 'มัดจำถังน้ำ 1'
          )

          if (findPledgeWaterTankProduct > -1) {
            return true
          }
        }
      }
      return false
    },
    banktransferinfo_photo() {
      if (this.isTremendous) {
        if (this.isTremendousPledgeWaterTank) {
          return this.pageProfile &&
            this.pageProfile.deposit_bank_transfer_info_image
            ? this.pageProfile.deposit_bank_transfer_info_image
            : null
        } else {
          return this.pageProfile && this.pageProfile.banktransferinfo_photo
            ? this.pageProfile.banktransferinfo_photo
            : null
        }
      } else {
        return this.pageProfile && this.pageProfile.banktransferinfo_photo
          ? this.pageProfile.banktransferinfo_photo
          : null
      }
    },
    billing_total() {
      // ราคารวม ยังไม่หักส่วนลด
      if (this.pageProfile.vat && this.pageProfile.vat > 0) {
        return this.totalBeforeVat
      }
      return this.total + this.additional_price
    },
    billing_subtotal() {
      // ราคารวมส่วนลด และก่อนหักภาษี
      let bundleDiscount = 0
      if (this.$store.state.bundles.bundleDiscount) {
        bundleDiscount =
          this.$store.state.bundles.bundleDiscount.nestle_discount_bundle
      }

      if (this.pageProfile.vat && this.pageProfile.vat > 0) {
        return this.billing_total - this.discount - bundleDiscount
      }
      return this.totalincludediscount + this.additional_price - bundleDiscount
    },
    additional_price() {
      let additional_price = 0
      try {
        additional_price = this.cart.reduce((prev, curr) => {
          prev += curr.additional_price
          return prev
        }, 0)
      } catch (error) {
        //
      }
      return additional_price
    },
    totalPrice() {
      const vm = this
      // ราคาหลังหักภาษีและค่าขนส่งแล้ว
      var total = vm.billing_subtotal

      total += vm.excluded_vat
      if (
        vm.product_detail_json &&
        vm.product_detail_json.created_by.includes('admin')
      ) {
        return parseFloat(vm.product_detail_json.amount)
      } else {
        return total + parseFloat(vm.shippingPrice || 0)
      }
    },
    excluded_vat() {
      const vm = this
      let vat = 0
      if (vm.pageProfile.vat) {
        vat = vm.$store.getters.totalVat
        vat = vm.roundNumber(vat)
      }
      return vat
    },
    shippingPrice() {
      var total = this.billing_subtotal
      var shippingPrice = 0

      if (this.isBearhouse) {
        shippingPrice = this.bearhouseshippingprice
      } else if (this.isCDS) {
        shippingPrice = this.cdsshippingprice
      } else if (this.isKullastri) {
        var kullastriPrice = total >= 500 ? 0 : 60
        shippingPrice = kullastriPrice
      } else if (this.isBSC) {
        var BscPrice = total >= 500 ? 0 : 42
        shippingPrice = BscPrice
      } else if (this.shippingType) {
        if (this.isSmoothE) {
          var smootheShippingPrice = total >= 500 ? 0 : this.shippingType.value
          shippingPrice = smootheShippingPrice
        } else
          shippingPrice = this.isNumber(this.shippingType.value)
            ? this.shippingType.value
            : 0
      } else {
        //
      }

      // discount with voucher
      if (shippingPrice && this.voucher) {
        if (this.voucher.freeship) {
          if (
            this.shippingType.type == 'cod_charge' &&
            this.exceptCashOnDelivery
          ) {
            //
          } else {
            shippingPrice = 0
          }
        } else if (shippingPrice > this.voucher.discountship) {
          shippingPrice = shippingPrice - this.voucher.discountship
        } else {
          shippingPrice = 0
        }
      }

      // transport cost
      if (this.transport_code && this.transport_cost)
        shippingPrice += this.transport_cost

      return shippingPrice
    },
    customerShippingPrice() {
      if (this.isKullastri) {
        return this.billing_total >= 500 ? 0 : 60
      } else if (this.isBSC) {
        return this.billing_total >= 500 ? 0 : 42
      } else {
        return 0
      }
    },
    payment_option() {
      if (['104716585038207', '362065616073'].includes(this.pageProfile.pageid))
        return 'CC'
      else if (this.pageProfile.type == 'nestle') {
        return 'ALL'
      }
      return 'ALL'
    },
    showOnlyQRpage() {
      return ['141179435910975'].includes(this.pageid)
    },
    ...mapGetters({
      cart: 'getCart',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme',
      getSalePage: 'getSalePage',
      totalBeforeVat: 'totalBeforeVat'
    }),
    hasPaymentMethodMoreThanOne() {
      return (
        this.pageProfile.fbpay_status ||
        this.pageProfile.gbprime_status ||
        (this.shippinglist &&
          this.shippinglist.hasOwnProperty('cod_charge') &&
          this.shippinglist['cod_charge'][1]) ||
        this.pageProfile.paypal_merchantid
      )
    },
    paymentList() {
      let payments = []

      if (this.allowtransfer) {
        payments.push('transfer')
      }

      if (this.pageProfile.gbprime_status) {
        payments.push('gbprime')
      }

      if (this.pageProfile.gbprime_mobile_banking_status) {
        payments.push('gbprime_mobile_banking')
      }

      if (
        this.$store.state.page2c2p.includes(this.pageid) ||
        this.pageProfile.type == 'bec' ||
        this.$store.state.theme2c2p.includes(this.pageProfile.type)
      ) {
        payments.push('2c2p')
      }

      if (this.isOmiseEnabled) {
        payments.push('omise')
      }
      if (
        this.$store.state.gbpayment.includes(this.pageid) ||
        this.pageProfile.gbprimecredit_status
      )
        payments.push('creditgbprime')

      if (
        this.pageProfile.fbpay_status &&
        !this.$store.state.cds.includes(this.pageid)
      ) {
        payments.push('fbpay')
      }
      if (this.allowcreditcard && this.pageProfile.paypal_merchantid) {
        payments.push('paypal')
      }

      if (
        this.shippinglist &&
        this.shippinglist.hasOwnProperty('cod_charge') &&
        this.shippinglist['cod_charge'][1]
      ) {
        payments.push('cod')
      }

      if (this.isTremendous && this.isTremendousPledgeWaterTank) {
        payments = ['transfer']
      }

      payments = [
        ...payments,
        ...this.$store.state.paymentGateways.map(
          (payment) => `paymentgateway(${payment.id})`
        )
      ]

      return payments
    },

    bearhouseshippingprice() {
      var zipcode = this.shippingAddress2.zipcode
      return bearhousecalculateshippingprice(zipcode, this.cart.length)
    },
    foodguruShippingList() {
      var cart = this.cart
      var zipcode = this.shippingAddress2.zipcode
      var billingTotal = this.billing_total
      // eslint-disable-next-line no-undef
      var shippinglist = _.cloneDeep(this.shippinglist)

      var rate = foodguruShippingRate(zipcode)
      var isFreshProduct = cart.find(function (val) {
        return val.producttype == 'ของสด'
      })

      var AbleShippinglist = []
      if (rate == 'BKK') {
        if (isFreshProduct) {
          AbleShippinglist = ['scgexpress_charge', 'skootar_charge']
        } else {
          AbleShippinglist = ['flash_charge']
        }
      } else {
        if (isFreshProduct) {
          AbleShippinglist = ['scgexpress_charge']
        } else {
          AbleShippinglist = ['flash_charge']
        }
      }

      var foodguruShipping = Object.keys(shippinglist)
        .filter((key) => AbleShippinglist.includes(key))
        .reduce((obj, key) => {
          obj[key] = shippinglist[key]
          obj[key]['rate'] = rate

          if (key == 'scgexpress_charge' || key == 'flash_charge') {
            var price = foodguruCalShippingPrice(rate, key, billingTotal)
            obj[key][0] = price
          }

          return obj
        }, {})

      return foodguruShipping
    },
    ableToBuy() {
      return this.ableToShipping
    },
    cdsshippingprice() {
      var zipcode = this.shippingAddress2.zipcode
      if (
        [
          '634199670052309',
          '392612533487',
          '460631194141528',
          '291451944586723'
        ].includes(this.pageProfile.pageid) &&
        this.billing_total >= 599
      ) {
        return 0
      } else if (
        [
          '160733491520',
          '102855154730088',
          '1322459104509147',
          '107235216024674',
          '100169865799063'
        ].includes(this.pageProfile.pageid) &&
        this.billing_total >= 699
      ) {
        return 0
      } else if (
        ['122424499005', '134297248716', '105516258950290'].includes(
          this.pageProfile.pageid
        )
      ) {
        return 0
      } else {
        return cdsshippingprice(zipcode, this.billing_subtotal)
      }
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    isOoca() {
      return (
        this.pageProfile &&
        ['100935418246290', '142088386194745'].includes(this.pageProfile.pageid)
      )
    },
    isKullastri() {
      return (
        this.pageProfile &&
        this.$store.state.kullastripage.includes(this.pageProfile.pageid)
      )
    },
    isBSC() {
      return (
        this.pageProfile &&
        this.$store.state.bscpage.includes(this.pageProfile.pageid)
      )
    },
    isSmoothE() {
      return this.pageProfile && this.pageProfile.type == 'smoothe'
    },
    isFoodguru() {
      return this.pageProfile && this.pageProfile.type == 'foodguru'
    },
    isYasale() {
      return this.pageProfile && this.pageProfile.type === 'yasale'
    },
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    },
    extractShippingZipcode() {
      var zipcode = ''
      if (
        this.shippingAddress &&
        this.shippingAddress.match(/([A-z]|[ก-๛]|\s)[1-9][0-9]{4}/g)
      ) {
        zipcode = this.shippingAddress
          .match(/([A-z]|[ก-๛]|\s)[1-9][0-9]{4}/g)[0]
          .trim()
        zipcode = zipcode.match(/([1-9][0-9]{4})|^([1-9][0-9]{4})/)[0]
      }
      return zipcode
    },
    cityFreshBookingTimeOptions() {
      const selectedDate = this.inputCityFresh.booking_date
        ? this.inputCityFresh.booking_date
        : moment().format('YYYY-MM-DD')

      const options = [
        {
          label: '08.00-10.00',
          disable: !moment().isBefore(
            moment(selectedDate).format('YYYY-MM-DD 08:00')
          )
        },
        {
          label: '10.00-12.00',
          disable: !moment().isBefore(
            moment(selectedDate).format('YYYY-MM-DD 10:00')
          )
        },
        {
          label: '12.00-14.00',
          disable: !moment().isBefore(
            moment(selectedDate).format('YYYY-MM-DD 12:00')
          )
        },
        {
          label: '14.00-16.00',
          disable: !moment().isBefore(
            moment(selectedDate).format('YYYY-MM-DD 14:00')
          )
        }
      ]
      return options
    }
  },
  watch: {
    selectedAddress: {
      handler: function (selectedAddress) {
        if (selectedAddress) {
          const address = this.shippingAddressList.find(
            (x) => x.id == selectedAddress
          )
          if (address.address_lat && address.address_long) {
            this.address_lat = address.address_lat
            this.address_long = address.address_long
          }
          if (address && address.address) {
            this.shippingAddress = address ? address.address.address : ''
            this.shippingAddress2 = {
              ...address.address,
              address: ''
            }
            this.customerName =
              address.address && address.address.name
                ? address.address.name
                : address.name
                ? address.name
                : '-'

            this.customerPhone =
              address.address && address.address.tel
                ? address.address.tel
                : address.tel
                ? address.tel
                : '-'
          }
        }
      }
    }
  },
  methods: {
    submitGbprimeMobileBanking() {
      this.$refs.formgbprime.submit()
    },
    async genGbHash() {
      const body = {
        ...this.gbFormData,
        backgroundUrl: `${this.gbFormData.backgroundUrl}?userid=${this.userid}&pageid=${this.pageid}`,
        page_id: this.pageid
      }
      const responseData = await axios.post(
        `${config.getConfig('serverUrl')}api/tremendous/gbprime-hash`,
        body
      )
      if (
        responseData &&
        responseData.data &&
        responseData.data.key &&
        responseData.data.hash
      ) {
        this.gbFormData.hash = responseData.data.hash
        this.gbFormData.public_key = responseData.data.key
      }
    },
    async loadCheckBranch(pageid) {
      const resposne = await axios.get(
        `${config.getConfig('serverUrl')}shop-service-branchs/check-branch`,
        {
          params: { pageId: pageid },
          headers: {
            AUTHORIZATION:
              'Bearer endpei5haTpzaG9wLXNlcnZpY2VAY2hlY2stYnJhbmNocw=='
          }
        }
      )
      this.$store.commit(
        'SET_SHOP_MAIN_PRODUCT',
        resposne.data.shop_main_pageid || null
      )
    },
    handleSelectedGiveAwayProduct(item) {
      this.selectedGiveAwayProduct = item
    },
    requiredCharacterLength(params) {
      try {
        if (config.env !== 'shopcommu') {
          if (params.requiredNineCharacter && params.requiredTenCharacter) {
            return /^\s*-?[0-9]{9,10}\s*$/
          } else if (
            params.requiredNineCharacter &&
            !params.requiredTenCharacter
          ) {
            return /^\s*-?[0-9]{9}\s*$/
          } else if (
            !params.requiredNineCharacter &&
            params.requiredTenCharacter
          ) {
            return /^\s*-?[0-9]{10}\s*$/
          } else {
            return /^\s*-?[0-9]{1,100}\s*$/
          }
        } else {
          return /^\s*-?[0-9]{9,10}\s*$/
        }
      } catch (error) {
        return /^\s*-?[0-9]{9,10}\s*$/
      }
    },
    selectCODLalamove() {
      this.$swal
        .fire({
          title: 'ค่าจัดส่งอาจมีการเปลี่ยนแปลง',
          text: 'ตามเงื่อนไขที่ทาง Lalamove กำหนด กรุณาตรวจสอบอีกครั้ง',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        .then(async (result) => {
          if (result.value) {
            if (this.lalamove.result) {
              this.lalamove.result.specialRequests = ['COD']
            }
            this.lalamove.cod = true
            this.gmapLocation()
          }
        })
    },
    onMapLoading(val) {
      this.loadingMapInfo = val
    },
    onCheckInvoice(val) {
      if (val == 'true') {
        //
        this.setTaxInvoice()
      } else {
        this.taxAddress = null
        this.tax_id = ''
        this.tax_name = ''
      }
    },
    isNumber(value) {
      let val = null
      try {
        val = parseInt(value)
      } catch (error) {
        return false
      }
      return typeof val === 'number' && isFinite(val)
    },
    checkShopOption(field) {
      if (this.shopOption) {
        for (var i = 0; i < this.shopOption.length; i++) {
          if (this.shopOption[i].label === field) {
            return this.shopOption[i]
          }
        }
      }
    },
    onBlurAddress() {
      let json = {
        userid: this.userid,
        name: this.customerName,
        phone: this.customerPhone,
        addresno: this.shippingAddress,
        address: this.shippingAddress2,
        email:
          this.shopOption &&
          this.shopOption.length > 0 &&
          this.shopOption[2].message
            ? this.shopOption[2].message
            : ''
      }
      let tmpaddress = []
      try {
        if (localStorage.getItem('tmpaddress')) {
          tmpaddress = JSON.parse(localStorage.getItem('tmpaddress'))

          if (typeof tmpaddress != 'object') {
            tmpaddress = []
          }
        }
      } catch (error) {
        //
      }
      try {
        let index = tmpaddress.findIndex((el) => {
          return el.userid == this.userid
        })
        if (index == -1) tmpaddress.push(json)
        else tmpaddress[index] = json
        localStorage.setItem('tmpaddress', JSON.stringify(tmpaddress))
      } catch (error) {
        //
      }

      if (this.updateAddressTimeout) {
        clearTimeout(this.updateAddressTimeout)
      }
      // this.fetchLoading = true
      this.updateAddressTimeout = setTimeout(() => {
        this.setAddress(json)
      }, 3000)
    },
    async setAddress(json) {
      try {
        if (this.userid) {
          //
          let { combine_address } = this.combineAddress()

          let json_value = {
            name: json.name,
            phone: json.phone,
            address: combine_address,
            email: json.email
          }

          let data = {
            userid: this.userid,
            pageid: this.pageid,
            shipping_address_json: JSON.stringify(json_value),
            email:
              this.shopOption && this.shopOption.length > 0
                ? this.shopOption[2].message
                : ''
          }

          let response = await axios.post(
            `${config.getConfig('serverUrl')}save_user_shipping_address`,
            data,
            {
              params: {},
              headers: {
                'api-key': '1-2-3-sharks-landed'
              }
            }
          )
          if (response) {
            if (response.status === 200) {
              // console.log(response);
            }
            this.fetchLoading = false
          }
        }
      } catch (error) {
        this.fetchLoading = false
        // eslint-disable-next-line no-console
        console.error(error)
      }
      this.checkShippingPrice()
      this.fetchLoading = false
    },
    async checkShippingPrice() {
      let vm = this
      if (config.env == 'shop') {
        // เช็คพื้นที่ห่างไกล
        try {
          vm.loading = true
          if (
            vm.transport_lists == null ||
            (vm.shippingAddress2.zipcode &&
              vm.shippingAddress2.zipcode != vm.remotePostcode)
          ) {
            vm.remotePostcode = vm.shippingAddress2.zipcode
            let is_island = false
            try {
              is_island = vm.shippingAddress
                ? vm.shippingAddress.includes('เกาะ')
                : false
            } catch (error) {
              //
            }

            let data = {
              // shipping_name: shippingtype,
              postcode: vm.shippingAddress2.zipcode,
              province_name_th: vm.shippingAddress2.province, // (Optional)
              district_name_th: vm.shippingAddress2.district, // (Optional)
              sub_district_name_th: vm.shippingAddress2.sub_district, // (Optional)
              is_island: is_island // (Optional)
            }

            let response = await axios.post(
              `${config.getConfig('serverUrl')}shop/${
                vm.pageProfile.pageid
              }/check-transport`,
              data,
              {
                params: {},
                headers: {
                  AUTHORIZATION: `BEARER xxx xxx`,
                  'api-key': '1-2-3-sharks-landed'
                }
              }
            )
            if (response && response.status === 200) {
              if (response.data.success && response.data.result) {
                vm.transport_lists = response.data.result || []
                if (vm.transport_lists && vm.transport_lists.length > 0)
                  await vm.checkRemoteAreaShippingPrice()
              } else {
                vm.transport_lists = []
              }
            } else {
              vm.transport_lists = []
            }
          } else {
            await vm.checkRemoteAreaShippingPrice()
          }
          vm.loading = false
        } catch (error) {
          Sentry.captureException(error)
        }
      } else if (config.env == 'shopcommu') {
        if (vm.pageProfile.type == 'cityfresh' && vm.shippingAddress2.zipcode) {
          const shippingtype = vm.shippingType ? vm.shippingType.type : null
          vm.transport_code = null
          vm.transport_cost = 0
          if (shippingtype == 'other_charge') {
            const zone = getFuzePostZone(vm.shippingAddress2.zipcode)
            if (zone) {
              vm.transport_code = zone
              switch (zone) {
                case 'NORTH_SOUTH_ESARN':
                  if (vm.weight <= 1000) {
                    vm.transport_cost = 200
                  } else {
                    vm.transport_cost = 260
                  }
                  break
                case 'BKK':
                  if (vm.weight <= 1000) {
                    vm.transport_cost = 100
                  } else if (vm.weight <= 2000) {
                    vm.transport_cost = 140
                  } else if (vm.weight <= 4000) {
                    vm.transport_cost = 180
                  }
                  break
                case 'EAST_WEST':
                  if (vm.weight <= 1000) {
                    vm.transport_cost = 160
                  } else {
                    vm.transport_cost = 240
                  }
                  break
                default:
                  break
              }
            }
          }
        }
      }
    },
    async checkRemoteAreaShippingPrice() {
      const shippingtype = this.shippingType ? this.shippingType.type : null
      this.transport_code = null
      this.transport_cost = 0

      if (this.shippingAddress2.zipcode) {
        if (this.transport_lists && this.transport_lists.length > 0) {
          let transport = this.transport_lists.find((el) => {
            return el.name == shippingtype
          })
          if (transport) {
            let { transport_code, transport_cost } = transport
            this.transport_code = transport_code
            this.transport_cost = transport_cost
          }
        } else {
          await this.checkShippingPrice()
        }
      }
    },
    getMindate() {
      let mindate = moment()
      var format = 'hh:mm:ss'
      if (this.pageProfile && this.pageProfile.type == 'alice') {
        // 23506 ขนมพร้อมส่งวันนี้
        // 23500 จองขนมล่วงหน้า

        let preorder = []
        if (this.cart && this.cart.length > 0) {
          preorder = this.cart.filter((el) => el.categoryid == 23500)
        }

        if (preorder.length > 0) {
          mindate = mindate.endOf('day')
        } else {
          mindate = mindate.startOf('day')
          var time = moment(moment(), format),
            beforeTime = moment('16:30:00', format),
            afterTime = moment('23:59:59', format)

          if (time.isBetween(beforeTime, afterTime)) {
            // late order
            mindate = mindate.endOf('day')
          } else {
            if (['map', 'pickup'].includes(this.chooseShippingType)) {
              // mindate = mindate.subtract(1, "days").endOf("day");

              mindate = mindate.subtract(1, 'days')
            }
          }
        }
      }

      return mindate.format('YYYY-MM-DD HH:mm')
    },
    inputValue(otp) {
      if (otp.length === 6) {
        this.validateOtp(otp)
      }
    },
    async getPrivacyNoticeEgg() {
      let url = config.getConfig('serverUrl') + `egg/privacy_notice`
      try {
        var response = await axios.get(url, {
          params: { pageid: this.pageProfile.pageid },
          headers: {
            'api-key': '1-2-3-sharks-landed'
          }
        })
        if (response) {
          if (response.status === 200) {
            this.privacy_notice =
              response.data.result.data.data['descriptionTh']
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    },
    async getTermAndConditionEgg() {
      let url = config.getConfig('serverUrl') + `egg/term_and_condition`
      try {
        var response = await axios.get(url, {
          params: { pageid: this.pageProfile.pageid },
          headers: {
            'api-key': '1-2-3-sharks-landed'
          }
        })
        if (response) {
          if (response.status === 200) {
            this.term_and_condition =
              response.data.result.data.data['descriptionTh']
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    },
    async requestOtpEgg() {
      this.dailogAddpoints = false
      this.loading = true
      let url = config.getConfig('serverUrl') + `egg/request_otp`
      try {
        var response = await axios.post(
          url,
          {
            phoneNumber: this.memberPhoneNumber
          },
          {
            params: { pageid: this.pageProfile.pageid },
            headers: {
              'api-key': '1-2-3-sharks-landed'
            }
          }
        )
        if (response) {
          if (response.status === 200) {
            this.loading = false
            this.refOtp = response.data.result.data
            this.dialogOtp = true
          }
        }
      } catch (error) {
        this.isAddPoints = false
        this.loading = false
        await this.$swal({
          title: this.$t('Error'),
          text: this.$t('Something went wrong. Please try it again.'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('Cancel'),
          reverseButtons: true
        })
      }
    },
    async validateOtp(otp) {
      this.dialogOtp = false
      this.loading = true
      let url = config.getConfig('serverUrl') + `egg/validate_otp`
      try {
        var response = await axios.post(
          url,
          {
            requester: this.refOtp.requester,
            reference: this.refOtp.reference,
            otp: otp,
            transactionId: this.refOtp.transactionId
          },
          {
            params: { pageid: this.pageProfile.pageid },
            headers: {
              'api-key': '1-2-3-sharks-landed'
            }
          }
        )
        if (response) {
          if (response.data.success) {
            this.loading = false
            this.dialogOtp = false
            this.registerMemberEgg()
          } else {
            this.isAddPoints = false
            this.loading = false
            this.dialogOtp = false
            await this.$swal({
              title: this.$t('Error'),
              text: this.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: this.$t('Confirm'),
              cancelButtonText: this.$t('Cancel'),
              reverseButtons: true
            })
          }
        }
      } catch (error) {
        this.isAddPoints = false
        this.dialogOtp = false
        this.loading = false
        await this.$swal({
          title: this.$t('Error'),
          text: this.$t('Something went wrong. Please try it again.'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('Cancel'),
          reverseButtons: true
        })
      }
    },
    allowedDates(val) {
      if (this.pageProfile.type == 'alice') {
        // 25480 จองขนมสาทรจีน
        let จองขนมสาทรจีน = this.cart.filter((p) => {
          return ['25480', '26372'].includes(p.categoryid.toString())
        })

        if (จองขนมสาทรจีน.length > 0) {
          let current_date = moment(new Date(val)).format('YYYY-MM-DD')

          return current_date == '2021-08-21' || current_date == '2021-08-22'
        }

        let day = moment.weekdays(true, moment(val).weekday()).toLowerCase()
        let weekdays = [
          { value: 'monday', value_th: 'จันทร์' },
          { value: 'tuesday', value_th: 'อังคาร' },
          { value: 'wednesday', value_th: 'พุธ' },
          { value: 'thursday', value_th: 'พฤหัสบดี' },
          { value: 'friday', value_th: 'ศุกร์' },
          { value: 'saturday', value_th: 'เสาร์' },
          { value: 'sunday', value_th: 'อาทิตย์' }
        ]
        let products = this.cart.filter((el) => {
          return el.name.match(/^[*]([A-Zก-๙-]+)[*]/g)
        })
        let chiffon = this.cart.filter((p) => {
          return ['23502'].includes(p.categoryid.toString())
        })
        let browny = this.cart.filter((p) => {
          return ['23498'].includes(p.categoryid.toString())
        })

        if (chiffon.length > 0 || (chiffon.length > 0 && browny.length > 0)) {
          // moment(val);

          // ควบคุมอุณหภูมิ
          if (day == 'thursday') {
            return true
          } else {
            return false
          }
        }

        if (products && products.length >= 1) {
          let availables = []
          if (products.length == 1) {
            availables = products[0].name.match(/^[*]([A-Zก-๙-]+)[*]/g)
            availables = availables[0].replaceAll('*', '')
            availables = availables.split('-')
          } else {
            availables = products
              .map((el) => {
                let val = el.name.match(/^[*]([A-Zก-๙-]+)[*]/g)
                return val.length > 0 ? val[0] : false
              })
              .filter((el) => el !== false)
            availables = availables.map((el) => {
              let val = el.replaceAll('*', '')
              val = val.split('-')
              return val
            })
            let target =
              availables && availables.length > 0 ? availables[0] : []
            availables = availables.forEach((el) => {
              // eslint-disable-next-line no-undef
              target = _.intersection(target, el)
            })
            availables = target
          }
          if (availables && availables.length > 0) {
            availables = availables
              .map((available) => {
                let weekday = weekdays.find((el) => {
                  return (
                    el.value_th == available ||
                    el.value == available.toLowerCase()
                  )
                })
                if (weekday) return weekday.value
                else return null
              })
              .filter((el) => {
                return el != undefined && el != null
              })

            var isAvailable = availables.find((el) => {
              return day == el
            })
            return isAvailable != null && isAvailable != undefined
          } else return false
        }
      } else if (this.pageProfile.type == 'cityfresh') {
        let chooseShippingType = this.chooseShippingType
        const now = moment(new Date())
        const diff = Math.round(now.diff(moment(new Date(val)), 'days', true))
        const isDay = moment(val).day()
        if (chooseShippingType === 'delivery') {
          return isDay == 0 || diff > -2 ? false : true
        } else if (chooseShippingType === 'lalamove') {
          return isDay == 0 || diff > 0 ? false : true
        }
      }
      return true
    },
    selectShippingType(type) {
      this.chooseShippingType = type
      this.notShipping = false
      if (this.pageProfile.type == 'alice') this.mindate = this.getMindate()

      this.pickupdate = null
      if (this.chooseShippingType === 'pickup') {
        this.shippingType = {
          type: null,
          value: 0
        }
      }

      if (['map', 'lalamove'].includes(this.chooseShippingType)) {
        //
      }

      this.checkRemoteAreaShippingPrice()
    },
    registerMemberEgg() {
      this.dailogAddpoints = false
      this.loading = true
      let url = config.getConfig('serverUrl') + 'egg/register_member'
      axios.defaults.headers.common = {
        'api-key': '1-2-3-sharks-landed'
      }
      axios
        .post(
          url,
          {
            phoneNumber: this.memberPhoneNumber
          },
          {
            params: {
              pageid: this.pageProfile.pageid
            }
          }
        )
        .then((response) => {
          this.loading = false
          if (response.data.success) {
            this.isAddPoints = true
            this.$swal({
              title: 'สำเร็จ',
              type: 'success',
              text: `ท่านทำการสมัครสมาชิกเรียบร้อยแล้ว`,
              confirmButtonText: this.$t('Confirm')
            })
          } else {
            this.dailogAddpoints = true
          }
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
          this.loading = false
          this.dailogAddpoints = true
          this.$swal({
            title: this.$t('Error'),
            text: this.$t('Something went wrong. Please try it again.'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            reverseButtons: true
          })
        })
    },
    CheckMemberPhoneNumber() {
      this.dailogAddpoints = false
      this.loading = true
      let url = config.getConfig('serverUrl') + 'egg/check_user_exist'
      axios.defaults.headers.common = {
        'api-key': '1-2-3-sharks-landed'
      }
      axios
        .get(url, {
          params: {
            pageid: this.pageProfile.pageid,
            phoneNumber: this.memberPhoneNumber
          }
        })
        .then((response) => {
          this.loading = false
          if (response.data.success) {
            this.isAddPoints = true
          } else {
            this.dailogAddpoints = true
            if (response.data.result.statusCode === '404') {
              this.isNotRegisterEgg = true
            } else {
              this.$swal({
                title: 'ผิดพลาด',
                type: 'error',
                text: `ไม่สามารถสะสมคะแนนได้ในขณะนี้
              กรุณาติดต่อร้านค้า`,
                confirmButtonText: this.$t('Confirm')
              })
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.dailogAddpoints = true
        })
    },
    gmapLocation() {
      this.loadingMapInfo = true
      let allowNewApi = [
        '134182372147489',
        '623635804423191',
        '103449625252826',
        '103434788896471',
        '100619629025288',
        '103733942270168'
      ].includes(this.pageProfile.pageid)
      var vm = this
      var locations = []
      var nearestlocation
      var stringlatlng =
        this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      let service
      if (!allowNewApi && !['cityfresh'].includes(this.pageProfile.type)) {
        // eslint-disable-next-line no-undef
        service = new google.maps.DistanceMatrixService()
      } else {
        // eslint-disable-next-line no-undef
        service = new google.maps.DirectionsService()
      }
      var origins = []
      // eslint-disable-next-line no-undef
      let start = new google.maps.LatLng(
          this.gmapvalue.lat.toString(),
          this.gmapvalue.lng.toString()
        ),
        end = []

      if (this.isFoodguru) {
        let location =
          this.branchlocation[0].lat.toString() +
          ',' +
          this.branchlocation[0].long.toString()
        origins.push(location)

        end = [
          {
            shop: this.branchlocation[0],
            // eslint-disable-next-line no-undef
            location: new google.maps.LatLng(
              this.branchlocation[0].lat.toString(),
              this.branchlocation[0].long.toString()
            )
          }
        ]
      } else {
        vm.shippingcostdistance.shoplocation.map((el) => {
          origins.push(el.lat_long)
        })
        end = this.shippingcostdistance.shoplocation
          .map((el) => {
            try {
              if (el.lat_long) {
                let lat_lng = el.lat_long.split(',')
                if (lat_lng.length > 1)
                  return {
                    shop: el,
                    // eslint-disable-next-line no-undef
                    location: new google.maps.LatLng(lat_lng[0], lat_lng[1])
                  }
              }
            } catch (error) {
              //
            }
            return false
          })
          .filter((el) => el != false)
      }

      if (this.isFoodguru) {
        //Foodguru
        foodguruDistanceCalculate(start, end)
        // service.getDistanceMatrix(
        //   {
        //     origins,
        //     destinations: [stringlatlng],
        //     travelMode: "DRIVING",
        //     region: "TH",
        //     drivingOptions: {
        //       departureTime: new Date(),
        //       trafficModel: "optimistic",
        //     },
        //   },

        // );
      } else {
        if (allowNewApi || ['cityfresh'].includes(this.pageProfile.type)) {
          this.findShortestRoute(start, end)
        } else {
          service.getDistanceMatrix(
            {
              origins,
              destinations: [stringlatlng],
              travelMode: 'DRIVING',
              region: 'TH',
              drivingOptions: {
                departureTime: new Date(),
                trafficModel: 'optimistic'
              }
            },
            callback
          )
        }
      }

      function callback(response, status) {
        if (status == 'OK') {
          vm.loadingMapInfo = true
          var bodyjson = response
          for (var i = 0; i < bodyjson.rows.length; i++) {
            var row = bodyjson.rows[i].elements[0].distance
            // console.log(vm.shippingcostdistance.shoplocation[i]);
            try {
              locations.push({
                ...vm.shippingcostdistance.shoplocation[i],
                distance: parseFloat((row.value / 1000).toFixed(2)),
                pictureurl: null
              })
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error(error)
            }
          }
          locations.sort((a, b) => {
            var x = a.distance
            var y = b.distance
            return x < y ? -1 : x > y ? 1 : 0
          })
          // originLatLng;
          nearestlocation = locations[0]
          nearestlocation.originAddresses = response.originAddresses[0]
          nearestlocation.destinationAddresses =
            response.destinationAddresses[0]

          vm.shippingAddress = nearestlocation.destinationAddresses
          var shop = vm.shippingcostdistance.shoplocation.find(
            (item) => item.id === nearestlocation.id
          )
          nearestlocation.shop_detail = shop
          nearestlocation.name = shop.name
          nearestlocation.id = shop.id
          vm.setPlacesInfoLabel(nearestlocation)
            .then((result) => {
              vm.placesinfolabel = result
            })
            .finally(() => {
              vm.loadingMapInfo = false
            })
        }
      }

      async function foodguruDistanceCalculate(start, end) {
        vm.loadingMapInfo = true
        let getDistancePromise = end.map((el) => {
          return vm.getDistance(start, el)
        })

        if (getDistancePromise.length == 0) {
          return
        }

        let getDistanceResponses = await Promise.all(getDistancePromise)
        getDistanceResponses = getDistanceResponses.filter((el) => el != false)
        let nearest = getDistanceResponses.reduce((prev, curr) => {
          let response = curr.response
          if (
            response.status == 'OK' &&
            response.routes &&
            response.routes.length > 0 &&
            response.routes[0].legs &&
            response.routes[0].legs.length > 0
          ) {
            if (prev) {
              if (
                prev.response.routes[0].legs[0].distance.value >
                response.routes[0].legs[0].distance.value
              ) {
                prev = curr
              }
            } else {
              prev = curr
            }
          }
          return prev
        })

        try {
          let leg = nearest.response.routes[0].legs[0]
          let nearestlocation = {
            name: nearest.name,
            distance: parseFloat((leg.distance.value / 1000).toFixed(2)),
            pictureurl: null,
            id: nearest.id,
            lat_long: leg.end_location.lat() + ',' + leg.end_location.lng()
          }
          vm.shippingAddress = leg.start_address
          nearestlocation.originAddresses = leg.start_address
          nearestlocation.originLatLng = leg.start_location
          nearestlocation.destinationAddresses = leg.end_address
          nearestlocation.destinationLatLng = leg.end_location
          nearestlocation.shop_detail = nearest.shop
          nearestlocation.name = nearest.name
          nearestlocation.id = nearest.id

          var address = leg.end_address
          const arrAddress = address.split(' ')

          var postcode = arrAddress[arrAddress.length - 2]
          var province = arrAddress[arrAddress.length - 3]
          var amphoe = arrAddress[arrAddress.length - 4]
          var district = arrAddress[arrAddress.length - 5]
          var shippingAddress = address.substring(0, address.indexOf('แขวง'))

          var rate = foodguruShippingRate(postcode)
          vm.foodguruDistance = nearestlocation

          var shippingPrice = foodguruCalShippingPrice(
            rate,
            'skootar_charge',
            vm.totalPrice,
            nearestlocation.distance
          )
          vm.ableToShipping = shippingPrice !== false

          vm.placesinfolabel =
            address +
            ` (${vm.foodguruDistance ? vm.foodguruDistance.distance : 0} Km)` +
            ` <div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: ${
              vm.ableToBuy ? 'green' : 'red'
            }">${
              vm.ableToBuy
                ? `ค่าส่ง ${shippingPrice} บาท`
                : ' ไม่สามารถจัดส่งได้'
            }</div>`
          vm.loadingMapInfo = false
          vm.loadingMap = false

          if (vm.ableToShipping) {
            vm.foodguruShippingList['skootar_charge'][0] = shippingPrice
            vm.foodguruDeliveryPrice = shippingPrice
            vm.shippingType = {
              type: 'skootar_charge',
              value: shippingPrice
            }

            vm.shippingAddress2.zipcode = postcode
            vm.shippingAddress2.province = province
            vm.shippingAddress2.district = amphoe
            vm.shippingAddress2.sub_district = district
            vm.shippingAddress = shippingAddress
          } else {
            vm.foodguruShippingList['skootar_charge'][0] = false
            vm.foodguruDeliveryPrice = false
            vm.shippingType = {
              type: 'skootar_charge',
              value: false
            }
          }

          try {
            // vm.placesinfolabel = await vm.setPlacesInfoLabel(nearestlocation);
          } catch (error) {
            //
          } finally {
            vm.loadingMapInfo = false
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        } finally {
          vm.loadingMapInfo = false
        }
      }
    },
    async findShortestRoute(start, end) {
      this.loadingMapInfo = true
      let getDistancePromise = end.map((el) => {
        return this.getDistance(start, el)
      })

      if (getDistancePromise.length == 0) {
        return
      }

      let getDistanceResponses = await Promise.all(getDistancePromise)
      getDistanceResponses = getDistanceResponses.filter((el) => el != false)
      let nearest = getDistanceResponses.reduce((prev, curr) => {
        let response = curr.response
        if (
          response.status == 'OK' &&
          response.routes &&
          response.routes.length > 0 &&
          response.routes[0].legs &&
          response.routes[0].legs.length > 0
        ) {
          if (prev) {
            if (
              prev.response.routes[0].legs[0].distance.value >
              response.routes[0].legs[0].distance.value
            ) {
              prev = curr
            }
          } else {
            prev = curr
          }
        }
        return prev
      })

      try {
        let leg = nearest.response.routes[0].legs[0]
        let nearestlocation = {
          name: nearest.name,
          distance: parseFloat((leg.distance.value / 1000).toFixed(2)),
          pictureurl: null,
          id: nearest.id,
          lat_long: leg.end_location.lat() + ',' + leg.end_location.lng()
        }
        this.shippingAddress = leg.start_address
        nearestlocation.originAddresses = leg.start_address
        nearestlocation.originLatLng = leg.start_location
        nearestlocation.destinationAddresses = leg.end_address
        nearestlocation.destinationLatLng = leg.end_location
        nearestlocation.shop_detail = nearest.shop
        nearestlocation.name = nearest.name
        nearestlocation.id = nearest.id

        try {
          this.placesinfolabel = await this.setPlacesInfoLabel(nearestlocation)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
          //
        } finally {
          this.loadingMapInfo = false
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        this.loadingMapInfo = false
      }
    },
    async getDistance(start, end) {
      // eslint-disable-next-line no-undef
      let service = new google.maps.DirectionsService()
      return new Promise((resolve, reject) => {
        service.route(
          {
            origin: start,
            destination: end.location,
            travelMode: 'DRIVING',
            region: 'TH',
            drivingOptions: {
              departureTime: new Date(),
              trafficModel: 'optimistic'
            }
          },
          (response, status) => {
            if (status == 'OK') {
              resolve({ shop: end.shop, response })
            } else {
              reject(false)
            }
          }
        )
      })
    },
    onMapReady() {
      // Ready
      this.loadingMap = false
    },
    async setPlacesInfoLabel(shop) {
      let distance_km = shop.distance,
        placesinfo = shop.originAddresses
      // var shop = this.shippingcostdistance.shoplocation.find((item) => item.id === id);
      if (shop) {
        var distance = shop.shop_detail.distance || []
        var lastEndDistance =
          distance.length > 0 && distance[0].endDistance
            ? JSON.parse(distance[distance.length - 1].endDistance)
            : null
        var lastEndPrice =
          distance.length > 0 && distance[0].price
            ? JSON.parse(distance[distance.length - 1].price)
            : 0
        var termsOption = shop.shop_detail.termsOption
        this.notShipping = false
        this.shippingType = {
          type: null
        }

        try {
          var ceiling_distance_km = 0
          ceiling_distance_km = distance_km.toFixed(2)
        } catch (error) {
          return false
        }
        var price = 0
        // this.shippingType.value = 0;
        this.$set(this.shippingType, 'value', 0)
        // - ซื้อครบ 1,000 ส่งฟรี
        // - ยอดสั่งซื้อขั้นต่ำ 200 บาท
        if (this.chooseShippingType == 'map') {
          let result = this.calculateShippingPriceFromGMap(
            ceiling_distance_km,
            distance,
            termsOption,
            lastEndDistance,
            lastEndPrice,
            shop
          )
          price = result.price
          this.notShipping = result.notShipping
          this.$set(this.shippingType, 'value', price)
        } else if (this.chooseShippingType == 'lalamove') {
          let shop_lat_long =
            shop.originLatLng && typeof shop.originLatLng == String
              ? shop.originLatLng.split(',')
              : [shop.originLatLng.lat(), shop.originLatLng.lng()]
          let customer_lat_long =
            shop.destinationLatLng && typeof shop.destinationLatLng == String
              ? shop.destinationLatLng.split(',')
              : [shop.destinationLatLng.lat(), shop.destinationLatLng.lng()]

          let customer_phone = this.customerPhone || '0000000000'
          if (customer_phone.charAt(0) == '0') {
            customer_phone = customer_phone.slice(1)
            customer_phone = '+66' + customer_phone
          }
          let request = {
            serviceType:
              this.weight < 20
                ? 'MOTORCYCLE'
                : this.weight < 100
                ? 'CAR'
                : 'SUV', // fix
            stops: [
              {
                location: {
                  lat: customer_lat_long[0].toString(), // lat ลูกค้า
                  lng: customer_lat_long[1].toString() // lng ลูกค้า
                },
                addresses: {
                  th_TH: {
                    displayString: shop.destinationAddresses,
                    market: 'TH_BKK' // fix
                  }
                }
              },
              {
                location: {
                  lat: shop_lat_long[0].toString(), // lat ร้านค้า
                  lng: shop_lat_long[1].toString() // lng ร้านค้า
                },
                addresses: {
                  th_TH: {
                    displayString: placesinfo,
                    market: 'TH_BKK' // fix
                  }
                }
              }
            ],
            requesterContact: {
              name: shop.shop_detail.name || 'Requester',
              phone: '+66092344758'
            },
            deliveries: [
              {
                toStop: 1, // fix
                toContact: {
                  name: this.customerName || 'null',
                  phone: customer_phone
                },
                remarks: 'Remarks for drop-off point (#1).' // ข้อความถึงคนขับ
              }
            ]
          }

          if (this.lalamove.cod) {
            request.specialRequests = ['COD']
          }
          // eslint-disable-next-line no-undef
          this.lalamove.result = _.cloneDeep(request)
          let result = await this.calculateShippingPriceFromLalamove(request)
          this.lalamove.shop_fee = shop.shop_detail.lalamoveFee
            ? parseInt(shop.shop_detail.lalamoveFee)
            : 0
          price = parseInt(result.price) + this.lalamove.shop_fee
          this.notShipping = result.notShipping
          this.lalamove.fee = parseInt(result.price)
          this.$set(this.shippingType, 'value', price)
        }

        this.checkShippingPrice()
        this.shopName = shop.shop_detail.name
        return (
          placesinfo +
          ` (${ceiling_distance_km} Km) (${this.shopName}) ${
            price === false
              ? `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: red"> ไม่สามารถจัดส่งได้</div>`
              : `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: green">ค่าส่ง ${price} บาท</div>`
          }`
        )
      }
    },
    calculateShippingPriceFromGMap(
      ceiling_distance_km,
      distance,
      termsOption,
      lastEndDistance,
      lastEndPrice,
      shop
    ) {
      if (shop.shop_detail) {
        shop = shop.shop_detail
      }

      let price = 0,
        notShipping = true
      if (
        ceiling_distance_km <= 18 &&
        this.billing_total >= 1000 &&
        this.pageProfile.type == 'mookata'
      ) {
        this.shippingType.value = 0
      } else if (
        this.billing_total < 200 &&
        this.pageProfile.type == 'mookata'
      ) {
        price = false
        notShipping = true
      } else if (
        this.pageProfile.pageid === '100619629025288' &&
        this.weightAll > 2 &&
        this.weightAll < 40
      ) {
        for (let i = 0; i < distance.length; i++) {
          if (ceiling_distance_km >= 0 && ceiling_distance_km <= 99.9) {
            notShipping = false
            price = 119 + parseInt(ceiling_distance_km).toFixed(2) * 9

            break
          } else if (
            ceiling_distance_km >= 100 &&
            ceiling_distance_km <= 149.9
          ) {
            notShipping = false
            price = 119 + parseInt(ceiling_distance_km).toFixed(2) * 7.5

            break
          } else if (
            ceiling_distance_km >= 150 &&
            ceiling_distance_km <= 499.9
          ) {
            notShipping = false
            price = 119 + parseInt(ceiling_distance_km).toFixed(2) * 7

            break
          } else if (ceiling_distance_km >= 500) {
            notShipping = false
            price = 119 + parseInt(ceiling_distance_km).toFixed(2) * 6.5

            break
          }
        }
      } else {
        for (let i = 0; i < distance.length; i++) {
          if (
            ceiling_distance_km >= JSON.parse(distance[i].startDistance) &&
            ceiling_distance_km <= JSON.parse(distance[i].endDistance)
          ) {
            notShipping = false
            price = distance[i].price

            break
          } else {
            if (termsOption === 'type1') {
              if (
                shop.optionType1.length > 0 &&
                JSON.parse(shop.optionType1[1]) > ceiling_distance_km
              ) {
                if (ceiling_distance_km > lastEndDistance) {
                  var overDistance = ceiling_distance_km - lastEndDistance
                  price =
                    overDistance.toFixed(0) * JSON.parse(shop.optionType1[0]) +
                    lastEndPrice
                  notShipping = false
                }
              } else {
                price = false
                notShipping = true
              }
            } else if (termsOption === 'type2') {
              if (ceiling_distance_km > lastEndDistance) {
                if (
                  shop.optionType2.length > 0 &&
                  JSON.parse(shop.optionType2[1]) > ceiling_distance_km
                ) {
                  price = JSON.parse(shop.optionType2[0])
                  notShipping = false
                } else {
                  price = false
                  notShipping = true
                }
              }
            } else {
              price = false
              notShipping = true
            }
          }
        }
      }

      return { price, notShipping }
    },
    async calculateShippingPriceFromLalamove(data) {
      const vm = this
      vm.loadingLalamove = true
      let price = 0,
        notShipping = true
      try {
        let response = await axios.post(
          `${config.getConfig('serverUrl')}lalamove/${
            this.pageProfile.pageid
          }/get-quotation`,
          data
        )

        if (response.status && response.data.success && response.data.result) {
          if (['cityfresh'].includes(this.pageProfile.type)) {
            // - เมื่อซื้อสินค้ามูลค่ารวมต่ำกว่า 1,000 บาท คิดค่าจัดส่ง 250 บาท
            // - เมื่อซื้อสินค้ามูลค่ารวมมากกว่า 1,000 บาท จัดส่งฟรีในกรุงเทพ
            // - เมื่อซื้อสินค้ามูลค่ารวมมากกว่า 1,000 บาท จัดส่งฟรีในงบ 250 บาท ส่วนเกินจ่ายโดยลูกค้า สำหรับการจัดส่งในพื้นที่ กทม. - ปริมณฑล
            const address = data.stops[1].addresses.th_TH.displayString
            const postcode = address.match(/[\d]{5}/g)
            if (
              postcode &&
              postcode.length > 0 &&
              getFuzePostZone(postcode[0]) == 'BKK'
            ) {
              price = this.billing_total <= 1000 ? 250 : 0
            } else {
              price =
                response.data.result.totalFee > 250
                  ? response.data.result.totalFee
                  : 250
            }
          } else {
            price = response.data.result.totalFee
          }
          notShipping = false
          vm.loadingLalamove = false
        } else {
          vm.loadingLalamove = false
        }
      } catch (error) {
        vm.loadingLalamove = false
        // eslint-disable-next-line no-console
        console.error(error)
      }

      return { price, notShipping }
    },
    async getShippingcostdistance() {
      try {
        let url = config.getConfig('serverUrl') + 'shippingcostdistance'
        axios.defaults.headers.common = {
          AUTHORIZATION: 'Bearer x x'
        }
        let response = await axios.get(url, {
          params: {
            pageid: this.pageid
          }
        })

        if (response.data.responsecode === 200) {
          if (
            response.data.shippingcostdistance &&
            response.data.shippingcostdistance.deliveryOption
          ) {
            this.deliveryOption =
              response.data.shippingcostdistance.deliveryOption
          }

          if (
            response.data.shippingcostdistance &&
            typeof response.data.shippingcostdistance.shoplocation ===
              'undefined'
          ) {
            let id = Math.floor(Math.random() * 1000000000)
            response.data.shippingcostdistance.shoplocation = [
              {
                name: response.data.shippingcostdistance[0].shopName,
                lat_long: `${response.data.shippingcostdistance[0].gmapvalue.lat}, ${response.data.shippingcostdistance[0].gmapvalue.lng}`,
                pictureurl: null,
                distance: response.data.shippingcostdistance[0].distance,
                optionType1: response.data.shippingcostdistance[0].optionType1,
                optionType2: response.data.shippingcostdistance[0].optionType2,
                termsOption: response.data.shippingcostdistance[0].termsOption,
                id: id
              }
            ]

            this.deliveryOption =
              response.data.shippingcostdistance[0].deliveryOption
          }
          this.googleapikey = response.data.googleapikey
          this.shippingcostdistance = response.data.shippingcostdistance
          if (
            this.shippingcostdistance &&
            this.shippingcostdistance.shoplocation.length > 0
          ) {
            if (this.deliveryOption && this.deliveryOption.length > 0) {
              this.chooseShippingType = this.deliveryOption[0]
            }
            this.shoplocation = this.shippingcostdistance.shoplocation
            this.getbranchlocation()
          } else {
            this.chooseShippingType = 'delivery'
            this.shoplocation = []
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    getbranchlocation() {
      var vm = this
      vm.showmap = false
      if (!this.externalScript) {
        this.externalScript = document.createElement('script')
        this.externalScript.setAttribute(
          'src',
          `https://maps.googleapis.com/maps/api/js?key=${vm.googleapikey}&language=th&libraries=places`
        )
        this.externalScript.async = true
        this.externalScript.defer = true
        this.externalScript.onload = () => {
          vm.showmap = true
        }
        document.head.appendChild(this.externalScript)
      }
    },
    getFoodgurubranchlocation() {
      var vm = this
      return new Promise((resolve) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'branchlocation?pageid=' +
              this.pageid
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              vm.branchlocation = response.data.branchlocation
              if (!vm.externalScript) {
                vm.externalScript = document.createElement('script')
                vm.externalScript.setAttribute(
                  'src',
                  `https://maps.googleapis.com/maps/api/js?key=${response.data.googlekey}&language=th&libraries=places`
                )
                vm.externalScript.async = true
                vm.externalScript.defer = true
                vm.externalScript.onload = () => {
                  vm.showmap = true
                  resolve()
                }
                document.head.appendChild(vm.externalScript)
              }
              // resolve();
            }
          })
      })
    },
    getRunkanProfileData() {
      var data = {
        pageid: this.pageid,
        userid: this.userid
      }
      return new Promise((resolve) => {
        axios
          .get(config.getConfig('serverUrl') + 'runkanmember', {
            params: data,
            headers: { AUTHORIZATION: 'Bearer xxxx xxx' }
          })
          .then(async (response) => {
            // console.log("response: ",response);
            if (response.data.responsecode == 200 && response.data.data) {
              // this. = response.data.data[0];
              this.customerName =
                response.data.data[0].first_name +
                ' ' +
                response.data.data[0].last_name
              this.shippingAddress2.zipcode = response.data.data[0].postcode
              this.shippingAddress2.province = response.data.data[0].province
              this.shippingAddress2.district = response.data.data[0].district
              this.shippingAddress = response.data.data[0].address
              this.shippingAddress2.sub_district =
                response.data.data[0].sub_district
              this.customerPhone = response.data.data[0].phoneno
              resolve()
            } else {
              if (
                response.data.reason ==
                'คุณพี่ยังไม่ได้สมัครสมาชิก กรุณาสมัครสมาชิกก่อนครับ'
              ) {
                // Page Test
                await this.$swal({
                  html:
                    'กรุณากรอกรายละเอียดก่อนการชำระเงิน<br/>' +
                    'ให้น้องรันกันหน่อยนะครับ',
                  confirmButtonColor: '#000',
                  confirmButtonText: this.$t('OK')
                }).then((result) => {
                  if (result.value) {
                    let pageid = this.pageProfile.pageid
                    let liffid = ''

                    if (pageid == '101211282011006') {
                      liffid = '1655728655-Jox9VpOD' // runkantest.zwiz.ai
                      // liffid = "1655728655-Q9gmOwRk"; // Test on localhost
                    } else if (pageid == '141495096441743') {
                      liffid = '1655728655-KyAxlvWJ' // runkan.zwiz.ai
                    }

                    this.$liff.openWindow({
                      url: `https://liff.line.me/${liffid}?view=Register&pageid=${pageid}&apptype=line`
                    })
                  }
                })
              } else {
                await this.$swal.fire({
                  text: response.data.reason
                })
                this.$liff.closeWindow()
              }
            }
          })
      })
    },
    changeHasShippingNow(hasShippingNow) {
      if (!hasShippingNow) {
        var shippinglist = Object.keys(this.shippinglist).map((key) => ({
          name: key,
          value: this.shippinglist[key]
        }))

        var shipping = shippinglist.filter((el) => {
          return (
            !['additionalproduct_charge', 'cod_charge'].includes(el.name) &&
            el.value[1]
          )
        })

        if (shipping && shipping.length > 0) {
          var val = shipping.find((el) => {
            return el.name == 'other_charge'
          })

          if (val) {
            this.shippingType = {
              type: val.name,
              value: val.value[0]
            }
            this.checkShippingPrice()
          }
        }
      }
    },
    async checkpageusepromocode() {
      var response = await axios.get(
        config.getConfig('serverUrl') + `checkpageusepromocode`,
        {
          params: {
            pageid: this.pageProfile.pageid
          }
        }
      )

      if (response.status == 200 && response.data.data) this.hasVoucher = true
    },

    async callafter() {},
    onUpdateTotal: async function (payload) {
      const vm = this
      vm.voucher = payload
      vm.timestamp = moment().format('x')
      if (payload !== null) {
        if (payload.promocodeby !== 'zwiz' || !vm.userid) {
          if (vm.voucher) {
            vm.voucher.discount = Math.floor(vm.voucher.discount)
            vm.total = vm.total
            vm.totalincludediscount =
              vm.total - vm.voucher.discount <= 0
                ? 0
                : vm.total - vm.voucher.discount
            vm.discount = vm.voucher.discount
          }
        } else {
          if (vm.voucher && vm.voucher.promoobj && vm.voucher.promoobj[0]) {
            vm.exceptCashOnDelivery =
              vm.voucher.promoobj[0].exclude_shipping_list === 'cod_charge'
                ? true
                : false
          }
          await vm.getUserCart(vm.pageProfile.shippinglist)
        }
      } else {
        if (vm.fixDiscount && vm.fixDiscount.match(/^[0-9]+$/)) {
          vm.discount = vm.fixDiscount
          if (vm.billing_total >= vm.discount) {
            vm.totalincludediscount = vm.billing_total - vm.discount
          } else {
            vm.totalincludediscount = 0
          }
        } else {
          vm.discount = 0

          await vm.getUserCart(vm.pageProfile.shippinglist)
        }
      }
    },
    calculateTotalAfterDiscount() {},
    replaceAddress(val) {
      if (!val || val.trim() == '') return ''
      return val
        .trim()
        .replace('เขต', '')
        .replace('แขวง', '')
        .replace('อำเภอ', '')
        .replace('ตำบล', '')
        .replace('จังหวัด', '')
    },

    setShippingDefault(type) {
      if (!this.shippinglist) return false
      if (type == 'cod_charge' && this.shippinglist['cod_charge']) {
        this.shippingType = {
          type: 'cod_charge',
          value: this.shippinglist['cod_charge'][0]
        }
        this.transferType = 'cod_charge'
      } else {
        var shippinglist = Object.keys(this.shippinglist).map((key) => ({
          name: key,
          value: this.shippinglist[key]
        }))
        var shipping = shippinglist.filter((el) => {
          return (
            !['additionalproduct_charge', 'cod_charge'].includes(el.name) &&
            el.value[1]
          )
        })
        if (shipping && shipping.length > 0) {
          if (this.shippingType && this.shippingType.type != 'cod_charge') {
            //
          } else {
            if (this.pageProfile.type == 'nvbb') {
              var val = shipping.find((el) => {
                return el.name == 'other_charge'
              })
              if (val) {
                this.shippingType = {
                  type: val.name,
                  value: val.value[0]
                }
              }
            } else {
              this.shippingType = {
                type: shipping[0].name,
                value: shipping[0].value[0]
              }
            }
          }
        }
      }
    },
    setTransferDefault() {
      if (this.paymentList.length > 0) {
        if (this.paymentList[0] == 'gbprime') {
          this.transferType = 'qrcode'
        } else if (this.paymentList[0] == 'cod') {
          this.shippingType = {
            type: 'cod_charge',
            value: this.shippinglist['cod_charge'][0]
          }
          this.transferType = 'cod_charge'
        } else {
          if (this.transferType && this.transferType != 'cod_charge') {
            //
          } else {
            var hasTransfer = this.paymentList.find((el) => {
              return el == 'transfer'
            })

            if (hasTransfer) this.transferType = 'transfer'
            else
              this.transferType = this.paymentList.filter(
                (el) => el != 'cod_charge'
              )[0]
          }
        }
      } else {
        this.transferType = 'transfer'
      }
    },
    onSelectAddress(address) {
      this.shippingAddress2.sub_district = address.district || ''
      this.shippingAddress2.district = address.amphoe || ''
      this.shippingAddress2.province = address.province || ''
      this.shippingAddress2.zipcode = address.zipcode || ''
    },
    testCentral2c2p() {
      return new Promise((resolve) => {
        let externalScript = document.createElement('script')
        externalScript.setAttribute(
          'src',
          `https://demo2.2c2p.com/2C2PFrontEnd/SecurePayment/api/my2c2p.1.6.9.min.js`
        )
        externalScript.async = true
        externalScript.defer = true
        externalScript.onload = () => {
          resolve()
        }
        document.head.appendChild(externalScript)
      })
    },
    changeShippingType(payload) {
      if (payload.type != 'cod_charge') {
        this.setTransferDefault()
      } else {
        this.setShippingDefault('cod_charge')
      }
      this.checkShippingPrice()
    },
    onChangeExpireDate(e) {
      var exp = e.split('/')

      if (exp && exp.length) {
        if (exp[0]) {
          this.creditcard.expiremonth = exp[0]
        } else {
          this.creditcard.expiremonth = exp[0]
        }
        if (exp[1]) {
          this.creditcard.expireyear =
            new Date().getFullYear().toString().substr(0, 2) + exp[1]
        } else this.creditcard.expireyear = ''
      }
    },
    submit2c2p() {
      // e.preventDefault();
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        // eslint-disable-next-line no-undef
        My2c2p.submitForm('2c2p-payment-form', function (errCode, errDesc) {
          if (errCode != 0) {
            vm.$swal({
              type: 'error',
              text: errDesc + ' (' + errCode + ')'
            })
          } else {
            // vm.handleSubmit();
            // vm.$refs.form2c2p.form.submit();
          }
        })
      })
    },
    async checkOrderStatus() {
      //   var total = numeral(0.01).format("0.00");
      var total = numeral(this.totalPrice).format('0.00')
      var response = await axios.get(
        config.getConfig('serverUrl') +
          `gbcompletedwithrefnoverify?referenceNo=${this.referenceNo}&pageid=${this.pageid}&userid=${this.userid}&amount=${total}`
      )
      return response
    },
    getByte(str) {
      var enc = new TextEncoder()
      return enc.encode(str)
    },
    requestQrCode2(photo) {
      // var vm = this;
      return new Promise((resolve, reject) => {
        if (photo) {
          // var photobyte = vm.getByte(photo);
          resolve(new Uint8Array(photo))
        } else {
          reject()
        }
      })
    },

    // not use in Transfer.vue
    async submitOrder() {
      const vm = this

      let transferType = vm.transferType

      if (vm.isEmptyShoppingCart) {
        return false
      }

      var data = { ...vm.formatOrderRequest(), ...vm.extraOrderRequest() }

      var shipping = vm.shippingType ? vm.shippingType.type : null
      if (
        vm.payment_slip_status &&
        transferType == 'transfer' &&
        shipping != 'cod_charge'
      ) {
        if (!vm.paymentSlipImage || vm.paymentSlipImage == '') {
          await vm.$swal({
            title: vm.$t('wait_for_proof'),
            text: vm.$t('please_send_your_payslip'),
            type: 'info',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        }
      }
      data.note = vm.paymentSlipImage

      if (transferType == 'qrcode') {
        data.paiddate = moment()
        data.transactionid = vm.referenceNo
      } else {
        data.paiddate = moment(`${vm.paiddate} ${vm.paidtime}`)
      }
      data.cart_ids = vm.$store.state.cart_ids || []

      try {
        var response = await vm.banktransfernotify(data)
        // JSON responses are automatically parsed.
        response = response.data
        if (response.responsecode == 200) {
          vm.isCompleted = true
          vm.isCompletePayment = true
          await vm.$store.dispatch('deleteAllItemsInCart')
          try {
            // eslint-disable-next-line
            if (vm.$liff.isInClient()) {
              var prefix_message = [
                '102459484852582',
                '102438735480946'
              ].includes(vm.pageProfile.pageid)
                ? 'ดำเนินการสั่งซื้อแพคเกจโควต้า Cart No. '
                : 'Order: '
              await vm.sendMessage(prefix_message + response.orderid)
              // eslint-disable-next-line no-undef
              await vm.$liff.closeWindow()
            } else {
              // eslint-disable-next-line no-undef
              if (MessengerExtensions) {
                // eslint-disable-next-line no-undef
                MessengerExtensions.requestCloseBrowser(
                  function success() {},
                  function error(err) {
                    Sentry.captureException(err)
                    window.close()
                  }
                )
              } else {
                window.close()
              }
            }
          } catch (error) {
            Sentry.captureException(
              `[Error] Send message -> Pageid: ${vm.pageid}, Order: ${
                response.orderid
              } , Userid: ${vm.userid || '-'}, responsecode: ${
                response.responsecode
              }`
            )
            Sentry.captureException(error)
          }
        } else if (response.responsecode == 201) {
          vm.isCompleted = true
          vm.isCompletePayment = true
          await vm.$store.dispatch('deleteAllItemsInCart')
          let url = '/ecommerce/' + vm.pagename
          if (vm.userid && vm.userid != null && vm.userid != '') {
            url += '?userid=' + vm.userid
          }
          vm.$router.push({ path: url })
        } else {
          Sentry.captureException(
            `[Error] Send message -> Pageid: ${vm.pageid}, Order: ${
              response.orderid
            } , Userid: ${vm.userid || '-'}, responsecode: ${
              response.responsecode
            }`
          )
          let message =
            response.reason == 'INVALID_CART_IDS'
              ? 'Your cart has changed. Please refresh to load the cart again.'
              : 'Something went wrong. Please try it again.'
          await vm.$swal({
            title: vm.$t('Error'),
            text: vm.$t(message),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('Cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        vm.loading = false
        // eslint-disable-next-line no-console
        console.error(error)
        Sentry.captureException(error)
        let message = 'Something went wrong. Please try it again.'
        if (error.response) {
          let data = error.response.data
          if (data.reason == 'INVALID_CART_IDS')
            message =
              'Your cart has changed. Please refresh to load the cart again.'
        }

        await vm.$swal({
          title: vm.$t('Error'),
          text: vm.$t(message),
          type: 'error',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('Cancel'),
          reverseButtons: true
        })
      }
    },

    async closeQrCode() {
      this.showQrCode = false
      clearInterval(this.qrcodeInterval)
    },
    async getQrCode2() {
      const vm = this
      var result = await vm.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        throw 400
      }

      try {
        vm.loadingQrcode = true
        let photo = await vm.gbcreaterefnofromcart()
        var response = await vm.requestQrCode2(photo)
        var binary = response.reduce(
          (data, b) => (data += String.fromCharCode(b)),
          ''
        )
        vm.qrimage = 'data:image/jpeg;base64,' + btoa(binary)
      } catch (error) {
        throw error
      }
      vm.loadingQrcode = false
    },
    async sendMessage(message) {
      try {
        // eslint-disable-next-line no-undef
        return await this.$liff.sendMessages([
          {
            type: 'text',
            text: message
          }
        ])
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)

        await axios.post(
          config.getConfig('serverUrl') +
            `line/${this.pageProfile.pageid}/send-message`,
          {
            userid: this.userid,
            sessiontoken: this.sessiontoken,
            message: message
          },
          {
            params: {},
            headers: { AUTHORIZATION: 'Bearer xxx xxx' },
            responseType: 'arraybuffer'
          }
        )
      }
    },
    async gbcreaterefnofromcart() {
      const vm = this
      try {
        var data = {
          ...vm.formatOrderRequest(),
          ...vm.extraOrderRequest()
        }

        if (vm.address_lat && vm.address_long) {
          data.address_lat = vm.address_lat
          data.address_long = vm.address_long
        }

        let detail = []
        vm.cart.map((el) => {
          detail.push(
            `${el.name}${el.option ? ` (${el.option})` : ''} x ${el.quantity}`
          )
        })

        let stringdetail = detail.join(',')
        if (stringdetail.length < 250) {
          stringdetail.slice(0, 250)
        }

        data.detail = stringdetail
        data.note = vm.paymentSlipImage
        if (vm.$route.query.from) {
          data.from = vm.$route.query.from
        } else {
          try {
            var device = vm.$liff.getOS()
            var version = vm.$liff.getVersion()
            await vm.$liff.ready

            if (
              vm.userid.indexOf('__') != -1 &&
              device &&
              version &&
              !vm.$liff.isInClient()
            ) {
              data.from = 'livechat'
            }
          } catch (error) {
            // eslint-disable-next-line
            console.log(error)
          }
        }
        if (
          !vm.userid ||
          (vm.hasCartarray && vm.getSalePage && vm.getSalePage.is_active)
        ) {
          data.userid = 'salepage'
          data.app = 'salepage'
          data.sessiontoken = 'salepage'
          data.salepage_productdetail = localStorage.getItem('cartarray')
        }
        data.cart_ids = vm.$store.state.cart_ids || []
        let response = null
        if (
          vm.product_detail_json &&
          vm.product_detail_json.created_by.includes('admin')
        ) {
          response = await axios.post(
            `${config.getConfig('serverUrl')}order/${vm.pageProfile.pageid}/${
              vm.$route.query.orderid
            }/generate-gb-qr`,
            {},
            {
              responseType: 'arraybuffer'
            }
          )
        } else {
          response = await axios.post(
            config.getConfig('serverUrl') + 'gbcreaterefnofromcart',
            data,
            {
              params: {},
              headers: { AUTHORIZATION: 'Bearer xxx xxx' },
              responseType: 'arraybuffer'
            }
          )
        }
        if (response.status == 200) {
          return response.data
        } else {
          let message =
            response.reason == 'INVALID_CART_IDS'
              ? 'Your cart has changed. Please refresh to load the cart again.'
              : 'Something went wrong. Please try it again.'
          await vm.$swal({
            title: vm.$t('Error'),
            text: vm.$t(message),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('Cancel'),
            reverseButtons: true
          })
          throw 400
        }
      } catch (error) {
        throw error
      }
    },
    getUserDetail: function () {
      const vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'lastorderaddress?pageid=' +
              vm.pageid +
              '&userid=' +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (response.data) {
                var gmapregex =
                  // eslint-disable-next-line no-useless-escape
                  /https\:\/\/www\.google\.com\/maps\?\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
                if (gmapregex.test(response.data.address)) {
                  var coords = response.data.address.match(gmapregex)[0]
                  coords = coords.split('@')[1].split(',')
                  vm.lastordercoords = { lat: coords[0], lng: coords[1] }
                }
                resolve(response.data)
              } else {
                resolve(null)
              }
            } else {
              reject()
            }
          })
      })
    },
    openModal: function () {
      this.showTerm = true
      let vm = this
      window.location.hash = '#modal-open'
      window.onpopstate = function () {
        if (location.hash == '#modal-open') {
          //   console.log("test");
        } else {
          vm.showTerm = false
        }
      }
    },
    close: function () {
      var vm = this

      if (window.history.length == 0) {
        vm.showTerm = false
      } else {
        window.history.back()
      }
    },
    getTransferDetail: async function () {
      let vm = this
      var response = await axios.get(
        config.getConfig('serverUrl') + 'banktransferinfo?pageid=' + vm.pageid
      )
      // JSON responses are automatically parsed.
      response = response.data
      if (response.responsecode == 200) {
        vm.allowtransfer =
          response.allowtransfer == true || response.allowtransfer == 'true'
        vm.banktransferinfo = response.banktransferinfo
        vm.banktransferinfo_photo = response.banktransferinfo_photo
      } else {
        //
      }

      return Promise.resolve()
    },
    async gbcreditSubmit() {
      const vm = this
      var result = await vm.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        return false
      }
      if (vm.isEmptyShoppingCart) {
        return false
      }
      vm.loading = true
      var response = await vm.getGBCreditToken()

      if (response.status == 200 && response.data.resultCode == '00') {
        var data = {
          ...vm.formatOrderRequest(),
          ...vm.extraOrderRequest()
        }
        data.creditcardtoken = response.data.card.token
        try {
          var order_response = null
          if (
            vm.product_detail_json &&
            vm.product_detail_json.created_by.includes('admin')
          ) {
            order_response = await axios.post(
              `${config.getConfig('serverUrl')}order/${vm.pageProfile.pageid}/${
                vm.$route.query.orderid
              }/generate-gb-card`,
              {
                token: response.data.card.token
              }
            )
          } else {
            order_response = await vm.banktransfernotify(data)
          }

          if (
            order_response.status == 200 &&
            order_response.data.responsecode == 200
          ) {
            vm.gbcharge = {
              gbpReferenceNo:
                vm.product_detail_json &&
                vm.product_detail_json.created_by.includes('admin')
                  ? order_response.data.result.gbpReferenceNo
                  : order_response.data.transactionid
            }
            await vm.$nextTick()
            vm.$refs.gbchargeform.submit()
          } else {
            vm.loading = false
            Sentry.captureException(
              `[Error] Send message -> Pageid: ${vm.pageid}, Order: ${
                order_response.data.orderid
              } , Userid: ${vm.userid || '-'}, responsecode: ${
                order_response.data.responsecode
              }`
            )
            let message =
              order_response.data.reason == 'INVALID_CART_IDS'
                ? 'Your cart has changed. Please refresh to load the cart again.'
                : 'Something went wrong. Please try it again.'
            await vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t(message),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('Cancel'),
              reverseButtons: true
            })
          }
        } catch (error) {
          vm.loading = false
          Sentry.captureException(
            `[Error] Send message -> Pageid: ${vm.pageid}, Order: ${
              order_response.orderid
            } , Userid: ${vm.userid || '-'}, responsecode: ${
              order_response.responsecode
            }`
          )
          // eslint-disable-next-line no-console
          Sentry.captureException(error)
          let message = 'Something went wrong. Please try it again.'
          if (error.response) {
            let data = error.response.data
            if (data.reason == 'INVALID_CART_IDS')
              message =
                'Your cart has changed. Please refresh to load the cart again.'
          }

          await vm.$swal({
            title: vm.$t('Error'),
            text: vm.$t(message),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('Cancel'),
            reverseButtons: true
          })
        }
      }
    },
    async getGBCreditCharge({ token, referenceNo }) {
      const vm = this
      var data = { ...vm.formatOrderRequest(), ...vm.extraOrderRequest() }

      let detail = []
      var secretKey = 'eoRYCmihqMtK7sHbikeitoRHigvY3xcb'
      vm.cart.map((el) => {
        detail.push(
          `${el.name}${el.option ? ` (${el.option})` : ''} x ${el.quantity}`
        )
      })

      let stringdetail = detail.join(',')
      if (stringdetail.length < 250) {
        stringdetail.slice(0, 250)
      }

      data.detail = stringdetail
      data.note = vm.paymentSlipImage
      data.referenceNo = referenceNo
      data.card = {
        token: token
      }
      data.otp = 'Y'
      data.responseUrl = 'https://payment.zwiz.ai/gbprime'
      var serverUrl = config.getConfig('serverUrl')
      data.backgroundUrl = serverUrl + 'gbprimebackendresult'
      data.amount = parseInt(data.amount) / 100
      if (vm.$route.query.from) {
        data.from = vm.$route.query.from
      } else {
        try {
          var device = vm.$liff.getOS()
          var version = vm.$liff.getVersion()
          await vm.$liff.ready

          if (
            vm.userid.indexOf('__') != -1 &&
            device &&
            version &&
            !vm.$liff.isInClient()
          ) {
            data.from = 'livechat'
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error)
        }
      }

      var url = `${vm.gbpath}/v1/tokens/charge`
      // delete axios.defaults.headers.common["Authorization"];
      axios.defaults.headers.common = {
        AUTHORIZATION: 'Basic ' + btoa(secretKey + ':')
      }
      return await axios.post(url, data, {})
    },
    async getGBCreditToken() {
      const vm = this
      var dataReq = {
        rememberCard: false,
        card: {
          name: vm.creditcard.name,
          number: vm.creditcard.number,
          expirationMonth: vm.creditcard.expiremonth,
          expirationYear: vm.creditcard.expireyear.substr(-2),
          securityCode: vm.creditcard.cvv
        }
      }
      if (vm.$route.query.from) {
        dataReq.from = vm.$route.query.from
      } else {
        try {
          var device = vm.$liff.getOS()
          var version = vm.$liff.getVersion()
          await vm.$liff.ready

          if (
            vm.userid.indexOf('__') != -1 &&
            device &&
            version &&
            !vm.$liff.isInClient()
          ) {
            dataReq.from = 'livechat'
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error)
        }
      }

      var url = `${vm.gbpath}/v1/tokens`
      // delete axios.defaults.headers.common["Authorization"];
      axios.defaults.headers.common = {
        AUTHORIZATION: 'Basic ' + btoa(vm.gbpublickey + ':')
      }
      return await axios.post(url, dataReq, {})
    },
    async qrHandleSubmit() {
      const vm = this
      try {
        await vm.getQrCode2()
        vm.showQrCode = true
        vm.checkQrCodeStatus()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    checkQrCodeStatus() {
      const vm = this
      let counter = 0
      vm.qrcodeInterval = setInterval(async () => {
        const response = await axios.post(
          `${config.getConfig('serverUrl')}api/gbprime/verify-gb-transaction`,
          { user_id: vm.userid, page_id: vm.pageid },
          {
            headers: {
              AUTHORIZATION: 'Bearer xxx xxx'
            }
          }
        )
        if (response) {
          counter++
          if (response.data && response.data.is_success) {
            vm.loadingQr = true
            clearInterval(vm.qrcodeInterval)
            vm.loadingQr = false
            vm.showQrCode = false
            vm.dialog = false

            vm.$swal
              .fire({
                title: vm.$t('payment_successful'),
                text: vm.$t('transaction_saved'),
                type: 'success',
                confirmButtonText: vm.$t('OK'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true,
                showCancelButton: true
              })
              .then(() => {
                location.reload()
              })
          } else if (counter == 50) {
            vm.loadingQr = false
            vm.showQrCode = false
            // vm.dialog = false
            // vm.refno = null
            clearInterval(vm.qrcodeInterval)
            vm.$swal.fire({
              title: vm.$t('payment_unsuccessful'),
              text: 'โปรดชำระเงินในเวลาที่กำหนด',
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true,
              footer: vm.$t('if_you_want_any_help_text')
            })
          }
        }
      }, 5000)
    },
    async handleSubmit(callback) {
      const vm = this
      var result = await vm.$validator.validateAll()
      if (
        vm.isTremendous &&
        (!vm.shippingAddress2 ||
          !vm.shippingAddress2.district ||
          !vm.shippingAddress2.province ||
          !vm.shippingAddress2.sub_district ||
          !vm.shippingAddress2.zipcode ||
          !vm.shippingAddress2.tel ||
          !vm.shippingAddress2.name)
      ) {
        vm.$swal.fire({
          text: 'กรุณากรอกที่อยู่',
          type: 'error'
        })
        return
      }
      if (vm.needTaxInvoice) {
        if (!vm.tax_name || !vm.taxAddress || !vm.tax_id) {
          vm.$swal.fire({
            text: 'กรุณากรอกข้อมูลในการออกใบเสร็จ',
            type: 'error'
          })
          return
        }
      }
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        if (callback && callback.onClearLoading) {
          callback.onClearLoading()
        }
        return false
      }
      if (
        vm.product_detail_json &&
        vm.product_detail_json.created_by.includes('admin')
      ) {
        vm.editAddressSubmit()
      } else {
        if (vm.pageProfile.type == 'nestle') {
          const result = await vm.$swal({
            title: 'สินค้าจะจัดส่งในประมาณ 3 วันทำการ ',
            text: 'สำหรับกรุงเทพฯและปริมณฑล และ ประมาณ 5 วันทำการสำหรับต่างจังหวัด กรุณาตรวจสอบรายละเอียดสินค้า และ สถานที่จัดส่งให้ถูกต้อง ถ้าหากชำระเงินแล้วจะไม่สามารถเปลี่ยนแปลงที่อยู่ได้ภายหลัง',
            type: 'info',
            confirmButtonText: vm.$t('ยืนยันความถูกต้อง'),
            cancelButtonText: vm.$t('ตรวจสอบข้อมูล'),
            showCancelButton: true,
            reverseButtons: true
          })

          if (!result.value) {
            return false
          }
        }
        if (vm.isEmptyShoppingCart) {
          return false
        }
        vm.paymentLoading = true
        vm.loading = true

        var data = { ...vm.formatOrderRequest(), ...vm.extraOrderRequest() }
        if (vm.address_lat && vm.address_long) {
          data.address_lat = vm.address_lat
          data.address_long = vm.address_long
        }
        var shipping = vm.shippingType ? vm.shippingType.type : null

        try {
          // Sentry.captureMessage(
          //   `Try to order -> Pageid: ${this.pageid}, Userid: ${this.userid || "-"}`
          // );
          var response = await vm.banktransfernotify(data)
          response = response.data
          if (response.responsecode == 200) {
            vm.isCompletePayment = true
            if (
              data.payment == '2c2p' &&
              (vm.isCDS ||
                vm.$store.state.page2c2p.includes(vm.pageProfile.pageid) ||
                vm.$store.state.theme2c2p.includes(vm.pageProfile.type))
            ) {
              vm.orderid = response.orderid
              vm.amount = data.total
              await vm.$nextTick()
              vm.submit2c2p()
            } else if (data.payment == 'gbprime_mobile_banking') {
              vm.referenceNo = response.referenceNo
              vm.amount = response.amount
              vm.gbFormData.referenceNo = response.referenceNo
              vm.gbFormData.amount = response.amount
              await vm.genGbHash()
              await vm.$nextTick()
              vm.submitGbprimeMobileBanking()
            } else if (data.payment == 'paysolutions') {
              vm.$store.commit('setPaymentGatewayData', {
                ...response.payment_gateway_data,
                orderid: response.orderid,
                pageid: vm.pageid,
                userid: vm.userid,
                sessiontoken: vm.sessiontoken
              })
              if (callback && callback.onProceed) {
                callback.onProceed()
              }
            } else if (data.payment == 'omise') {
              await vm.$nextTick()
              this.handlePayWithOmise({
                pageId: this.pageid,
                orderId: response.orderid,
                amount: response.amount
              })
            } else {
              try {
                // eslint-disable-next-line
                if (vm.$liff.isInClient()) {
                  if (['100733472248907'].includes(vm.pageProfile.pageid)) {
                    // bevita
                    Sentry.captureMessage(
                      `Send message -> Bevita, Userid: ${vm.userid || '-'}`
                    )
                  }
                  var prefix_message = [
                    '102459484852582',
                    '102438735480946'
                  ].includes(vm.pageProfile.pageid)
                    ? 'ดำเนินการสั่งซื้อแพคเกจโควต้า Cart No. '
                    : 'Order: '
                  await vm.sendMessage(prefix_message + response.orderid)
                  await vm.showCompletePopup(response, shipping)

                  vm.$liff.closeWindow()
                } else {
                  await vm.showCompletePopup(response, shipping)
                  // eslint-disable-next-line no-undef
                  // if (MessengerExtensions) {
                  //   // eslint-disable-next-line no-undef
                  //   MessengerExtensions.requestCloseBrowser(
                  //     function success() {},
                  //     function error(err) {
                  //       Sentry.captureException(err);
                  //       window.close();
                  //     }
                  //   );
                  // } else {
                  //   window.close();
                  // }
                }
              } catch (error) {
                Sentry.captureException(
                  `[Error] Send message -> Pageid: ${vm.pageid}, Order: ${
                    response.orderid
                  } , Userid: ${vm.userid || '-'}, responsecode: ${
                    response.responsecode
                  }`
                )
                Sentry.captureException(error)
                await vm.showCompletePopup(response, shipping)
              } finally {
                if (vm.userid && !vm.hasCartarray) {
                  vm.isCompleted = true
                }
                vm.$store.dispatch('deleteAllItemsInCart')
              }
            }
          } else if (response.responsecode == 400) {
            Sentry.captureException(
              `[Error] Send message -> Pageid: ${vm.pageid}, Order: ${
                response.orderid
              } , Userid: ${vm.userid || '-'}, responsecode: ${
                response.responsecode
              }`
            )
            if (
              response.reason === 'ONLY_ONE_ITEM_CAN_BE_PURCAHSED' ||
              response.reason === 'CAN_BUY_ONLY_1_ORDER_PER_DAY'
            ) {
              response.reason = 'only_one_item_can_be_purcahsed'
            }
            await vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t(response.reason),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('Cancel'),
              reverseButtons: true
            })
          } else if (response.responsecode == 201) {
            vm.isCompletePayment = true
            await vm.showCompletePopup(response, shipping)
            vm.$store.dispatch('deleteAllItemsInCart')
            let url = '/ecommerce/' + vm.pagename
            if (vm.userid && vm.userid != null && vm.userid != '') {
              url += '?userid=' + vm.userid
            }
            vm.$router.push({ path: url })
          } else {
            if (response.success) {
              vm.isCompletePayment = true
              await vm.showCompletePopup(response, shipping)
              localStorage.removeItem('cartarray')
            } else {
              Sentry.captureException(
                `[Error] Send message -> Pageid: ${vm.pageid}, Order: ${
                  response.orderid
                } , Userid: ${vm.userid || '-'}, responsecode: ${
                  response.responsecode
                }`
              )
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t('Something went wrong. Please try it again..'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            }
          }
          vm.paymentLoading = false
          vm.loading = false
        } catch (error) {
          if (callback && callback.onClearLoading) {
            callback.onClearLoading()
          }
          // eslint-disable-next-line no-console
          console.error(error)
          Sentry.captureException(error)
          vm.paymentLoading = false
          vm.loading = false
          let message = 'Something went wrong. Please try it again.'
          if (error.response) {
            let data = error.response.data
            if (data.reason == 'INVALID_CART_IDS')
              message =
                'Your cart has changed. Please refresh to load the cart again.'
          }
          vm.$swal({
            title: vm.$t('Error'),
            text: vm.$t(message),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('Cancel'),
            reverseButtons: true
          })
        }
      }
    },

    async showCompletePopup(response, shipping) {
      const vm = this
      if (['transfer', 'cod', 'cod_charge'].includes(vm.transferType)) {
        if (
          !vm.userid &&
          vm.hasCartarray &&
          vm.getSalePage &&
          vm.getSalePage.is_active
        ) {
          vm.countDown = 8
          vm.countDownTimer()
          vm.successDialog = true
          vm.orderid = response.orderid
        } else {
          if (
            vm.payment_slip_status &&
            vm.transferType == 'transfer' &&
            shipping != 'cod_charge' &&
            (!vm.paymentSlipImage || vm.paymentSlipImage == '') &&
            vm.$route.query &&
            !vm.$route.query.shoptoken
          ) {
            vm.loading = false
            await vm.$swal({
              title: vm.$t('wait_for_proof'),
              text:
                vm.$t('please_send_your_payslip') +
                ' ' +
                vm.$t('Your order number is') +
                `: ${response.orderid}`,
              type: 'info',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true,

              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              showConfirmButton: false
            })
          } else {
            vm.loading = false

            if (vm.isFoodguru) {
              const result = await vm.$swal({
                ...vm.getConpleteTransactionText(response.orderid),
                type: 'success',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showConfirmButton: true,
                confirmButtonText: vm.$t('Confirm')
              })
              if (result.value) {
                vm.$liff.closeWindow()
              }
            } else {
              if (vm.$route.query && vm.$route.query.shoptoken) {
                vm.$router.push({
                  path: `/transfer/${vm.pageid}?userid=${vm.userid}&sessiontoken=${vm.sessiontoken}&orderid=${response.orderid}`
                })
              } else {
                if (vm.pageProfile.type == 'seagull') {
                  const responsePopUp = await vm.$swal({
                    ...vm.getConpleteTransactionText(response.orderid),
                    type: 'success',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('Cancel'),
                    reverseButtons: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    showConfirmButton: true
                  })
                  if (responsePopUp && responsePopUp.value) {
                    vm.$router.push({
                      path: `/ecommerce/${vm.pageid}?userid=${vm.userid}&sessiontoken=${vm.sessiontoken}`
                    })
                    return
                  }
                  return
                } else {
                  await vm.$swal({
                    ...vm.getConpleteTransactionText(response.orderid),
                    type: 'success',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('Cancel'),
                    reverseButtons: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    showConfirmButton: vm.app === 'instagram' ? true : false
                  })
                }
              }
            }
            vm.isCompleted = true
          }
        }
      }
    },

    getConpleteTransactionText(orderid) {
      const title = this.$store.getters.isPowerBuyPage
        ? 'ทางเราได้สรุปข้อมูลไปยังแชทของลูกค้าเรียบร้อยแล้ว'
        : this.$t('Complete the transaction')
      const text =
        this.$store.getters.isPowerBuyPage || !orderid
          ? undefined
          : `${this.$t('Your order number is')}: ${orderid}`
      return {
        title,
        text
      }
    },

    async banktransfernotify(data) {
      const vm = this
      data.device_user_agent = window.navigator.userAgent
      if (vm.$route.query.from) {
        data.from = vm.$route.query.from
      } else {
        try {
          const device = vm.$liff.getOS()
          const version = vm.$liff.getVersion()
          await vm.$liff.ready
          if (
            !vm.userid &&
            vm.hasCartarray &&
            vm.getSalePage &&
            vm.getSalePage.is_active
          ) {
            //
          } else {
            if (
              vm.userid.indexOf('__') != -1 &&
              device &&
              version &&
              !vm.$liff.isInClient()
            ) {
              data.from = 'livechat'
            }
          }
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
        }
      }

      if (vm.fixDiscount) {
        data.admin_discount = vm.fixDiscount
      }
      data.cart_ids = vm.$store.state.cart_ids || []
      window.fbq('track', 'ProceedPayment', data.cart_ids)
      window.ttq.track('ProceedPayment', data.cart_ids)
      window.gtag('event', 'ProceedPayment', data.cart_ids)
      window.dataLayer.push({ ProceedPayment: data.cart_ids })
      let url = config.getConfig('serverUrl') + 'banktransfernotify'
      if (
        !vm.userid ||
        (vm.hasCartarray && vm.getSalePage && vm.getSalePage.is_active)
      ) {
        url += '?sessiontoken=' + 'salepage'
        data.userid = 'salepage'
        data.app = 'salepage'
        data.salepage_productdetail = localStorage.getItem('cartarray')
      } else {
        if (vm.sessiontoken != null || vm.sessiontoken != '') {
          url += '?sessiontoken=' + vm.sessiontoken
        }
      }
      if (vm.$route.query.shoptoken) {
        data.shop_token = vm.$route.query.shoptoken
      }
      if (vm.shopName && vm.chooseShippingType == 'map') {
        data.remark = data.remark + '  ' + '📍 สาขาที่ใกล้ ' + vm.shopName
      }
      if (vm.isAddPoints) {
        data.egg_crm_phone_no = vm.memberPhoneNumber
      }
      if (vm.$route.query.group_id) {
        data.group_id = vm.$route.query.group_id
      }
      if (vm.verifyData && vm.verifyData.verify_slip_ref) {
        data.verify_slip_bank_code = vm.verifyData.verify_slip_bank_code
        data.verify_slip_ref = vm.verifyData.verify_slip_ref
      }
      if (vm.voucher) {
        data.egg_crm_coupon = vm.voucher.promocode
        data.egg_crm_discount = vm.voucher.discount
      }
      if (vm.setShopOption && vm.shopOption.length !== 0) {
        vm.shopOption.map((item) => {
          if (typeof item.is_require === 'boolean') {
            if (item.id === '0') {
              item.message = data.name
            } else if (item.id === '1') {
              item.message = data.address
            } else if (item.id === '4') {
              item.message = data.phone
            }
          }
        })
        data.shop_addon_value_json = JSON.stringify(vm.shopOption)
      }

      if (vm.pageProfile.type == 'cityfresh') {
        if (vm.inputCityFresh.booking_date) {
          data.shippingdate = vm.inputCityFresh.booking_date
        }
        if (vm.inputCityFresh.booking_time) {
          data.shippingtime = vm.inputCityFresh.booking_time
        }
      }
      if (vm.isNestle) {
        data.discount_detail_json = {}
        if (vm.voucher && vm.voucher.promocode && vm.voucher.promoobj[0]) {
          Object.assign(data.discount_detail_json, {
            promotion_discount: [
              {
                id: vm.voucher.promoobj[0].id,
                name: vm.voucher.promoobj[0].name,
                code: vm.voucher.promoobj[0].code,
                discount: vm.voucher.promoobj[0].discountvalue
              }
            ]
          })
        }
        if (
          this.$store.state.bundles.bundleDiscount.nestle_bundle_id &&
          this.$store.state.bundles
        ) {
          const filterBundles = this.$store.state.bundles.bundles
            .filter((bundle) => {
              return this.$store.state.bundles.bundleDiscount.nestle_bundle_id.includes(
                bundle.id
              )
            })
            .map((item) => ({
              id: item.id,
              name: item.name,
              discount: item.discount
            }))
          if (filterBundles.length > 0) {
            Object.assign(data.discount_detail_json, {
              bundle_discount: filterBundles
            })
          }
        }
      }

      if (
        !data.discount_detail_json ||
        !Object.keys(data.discount_detail_json).length
      ) {
        delete data.discount_detail_json
      }
      return await axios.post(url, data)
    },
    combineAddress() {
      let combine_address = this.shippingAddress
          ? this.shippingAddress.replace(/,/g, '')
          : '',
        shipping_address = {}

      if (
        !this.useOldAddress.includes(this.pageProfile.pageid) &&
        this.shippingAddress2.sub_district &&
        this.shippingAddress2.district &&
        this.shippingAddress2.province &&
        this.shippingAddress2.zipcode
      ) {
        var inBangkok = this.shippingAddress2.province == 'กรุงเทพมหานคร'
        combine_address = combine_address.replace(
          this.shippingAddress2.zipcode,
          ''
        )
        combine_address =
          combine_address +
          ' , ' +
          [
            (inBangkok ? 'แขวง' : 'ตำบล') +
              this.shippingAddress2.sub_district.replace(/,/g, ''),
            (inBangkok ? 'เขต' : 'อำเภอ') +
              this.shippingAddress2.district.replace(/,/g, ''),
            'จังหวัด' + this.shippingAddress2.province.replace(/,/g, ''),
            this.shippingAddress2.zipcode.replace(/,/g, '')
          ].join(' , ')
        shipping_address = {
          name: this.customerName,
          province: this.shippingAddress2.province.replace(/,/g, ''),
          zipcode: this.shippingAddress2.zipcode.replace(/,/g, ''),
          district: this.shippingAddress2.district.replace(/,/g, ''),
          'sub-district': this.shippingAddress2.sub_district.replace(/,/g, ''),
          address: this.shippingAddress
            ? this.shippingAddress.replace(/,/g, '')
            : '',
          tel: this.customerPhone
        }
      }

      if (this.pageProfile.type == 'nestle') {
        shipping_address.email = this.inputNestle.email
      }

      return {
        combine_address,
        shipping_address
      }
    },
    formatOrderRequest() {
      const vm = this
      var total = vm.billing_total
      var shippingCharge = 0
      if (vm.shippingType) {
        shippingCharge = parseFloat(vm.shippingType.value || 0)

        total += shippingCharge
      }

      if (vm.transport_code && vm.transport_cost) {
        shippingCharge = shippingCharge + vm.transport_cost
        total = total + vm.transport_cost
      }

      let payment = null
      let paymentGateway = this.getPaymentGatewayById(vm.transferType)
      let paymentGatewaySetting = {}
      if (paymentGateway) {
        payment = paymentGateway.hosted_payment
        paymentGatewaySetting = {
          payment_gateway_id: paymentGateway.id,
          ...(paymentGateway.hosted_payment === 'paysolutions' && {
            paysolution_customer_data: {
              ...this.$store.state.paysolutionCustomerData
            }
          })
        }
      } else if (vm.transferType) {
        payment = vm.transferType
      }
      var note = vm.paymentSlipImage

      let { combine_address, shipping_address } = vm.combineAddress()
      var shipping = vm.shippingType ? vm.shippingType.type : null
      if (shipping && shipping.toLowerCase().indexOf('other') != -1) {
        shipping = vm.shippinglist[shipping][4]
      }

      let data = {
        amount: vm.totalPrice.toFixed(2).toString().replace('.', ''),
        pageid: vm.pageid,
        userid: vm.userid || 'salepage',
        app: vm.app,
        name: vm.customerName,
        address: combine_address,
        phone: vm.customerPhone,
        payment: payment,
        address_json:
          vm.tax_id === ''
            ? JSON.stringify({
                tax_id: null,
                tax_address: vm.taxAddress,
                tax_name: vm.tax_name
              })
            : JSON.stringify({
                tax_id: vm.tax_id,
                tax_address: vm.taxAddress,
                tax_name: vm.tax_name
              }),
        nameaddress:
          `${vm.customerName ? vm.customerName.replace(/,/g, '') : ''}` +
          `${combine_address !== '' ? ' , ' + combine_address : ''}` +
          `${
            vm.customerPhone
              ? ' , ' + vm.customerPhone.replace(/,/g, '')
              : ' , '
          }`,
        shippingtype: shipping,
        note: note,
        remark:
          vm.pageProfile.type == 'monobo'
            ? vm.remark + ';;' + vm.bankname
            : vm.remark,
        shippingcharge: shippingCharge.toFixed(2).toString().replace('.', ''),
        total: total.toFixed(2).toString().replace('.', ''),
        shipping_address: shipping_address,
        vat_amount: vm.excluded_vat,
        reference: vm.reference || undefined,
        giveaway: vm.selectedGiveAwayProduct
          ? [vm.selectedGiveAwayProduct]
          : undefined,
        ...paymentGatewaySetting
      }

      if (vm.pickupdate) {
        data.shipping_date = vm.pickupdate
      }
      if (vm.voucher) {
        data.promocode = vm.voucher.promocode
      }
      if (vm.sessiontoken != null || vm.sessiontoken != '') {
        data.sessiontoken = vm.sessiontoken
      }

      if (vm.isBearhouse) {
        data.shippingtype = 'other_charge'
        data.shippingcharge = vm.bearhouseshippingprice
          .toFixed(2)
          .toString()
          .replace('.', '')
        data.total = (vm.billing_total + vm.bearhouseshippingprice)
          .toFixed(2)
          .toString()
          .replace('.', '')
      }
      // central
      if (vm.isCDS) {
        data.shippingtype = 'other_charge'
        data.shippingcharge = vm.cdsshippingprice
          .toFixed(2)
          .toString()
          .replace('.', '')
        data.total = (vm.billing_total + vm.cdsshippingprice)
          .toFixed(2)
          .toString()
          .replace('.', '')
      }

      if (vm.isSmoothE) {
        var smootheShippingPrice = vm.billing_total >= 500 ? 0 : shippingCharge
        data.shippingcharge = smootheShippingPrice
          .toFixed(2)
          .toString()
          .replace('.', '')
        data.total = (vm.billing_total + smootheShippingPrice)
          .toFixed(2)
          .toString()
          .replace('.', '')
      } else if (vm.isKullastri) {
        var kullastriPrice = total >= 500 ? 0 : 60

        data.shippingcharge = kullastriPrice
          .toFixed(2)
          .toString()
          .replace('.', '')
        data.total = (vm.billing_total + kullastriPrice)
          .toFixed(2)
          .toString()
          .replace('.', '')
      } else if (vm.isBSC) {
        var BSCprice = total >= 500 ? 0 : 42

        data.shippingcharge = BSCprice.toFixed(2).toString().replace('.', '')
        data.total = (vm.billing_total + BSCprice)
          .toFixed(2)
          .toString()
          .replace('.', '')
      }

      if (vm.pageProfile.type == 'nvbb') {
        if (vm.hasShippingNow) {
          data.remark = (data.remark ? data.remark : '') + ' (จัดส่งทันที)'
        } else {
          data.remark = data.remark ? data.remark : ''
        }
      }

      if (['alice'].includes(vm.pageProfile.type)) {
        data.remark =
          (data.remark ? data.remark : '') +
          ' รับสินค้าวันที่ ' +
          moment(vm.pickupdate).format('DD/MM/YYYY')
        if (vm.isAutoPacking) {
          data.remark =
            (data.remark ? data.remark : '') + ' ให้ร้านจัดตามความเหมาะสม'
        }
      }

      if (['mookata'].includes(vm.pageProfile.type) && vm.isBorrowPan) {
        // borrowPanInfo;
        data.remark =
          (data.remark ? data.remark : '') +
          `\nชื่อ ${vm.borrowPanInfo.name}\nอายุ ${vm.borrowPanInfo.age}\nเลขบัตรปชช ${vm.borrowPanInfo.idcard} มีความประสงค์ขอยืมกระทะ`
      }

      if (vm.chooseShippingType == 'lalamove') {
        try {
          data.lalamove_order_json = JSON.stringify({
            ...vm.lalamove.result,
            totalFee: vm.lalamove.fee, // optional
            totalFeeCurrency: 'THB', // optional
            shop_fee: vm.lalamove.shop_fee
          })

          data.addon_json = JSON.stringify({
            shop_fee: vm.lalamove.shop_fee,
            cod: vm.lalamove.cod,
            weight: vm.weight
          })
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }

      if (vm.isYasale) {
        data.rtr_code = vm.rtrCode
      }

      return data
    },

    async getUserCart(shippinglist) {
      let vm = this

      if (
        vm.hasCartarray &&
        ((vm.getSalePage && vm.getSalePage.is_active) || !vm.userid)
      ) {
        axios.defaults.headers.common = {
          'api-key': '1-2-3-sharks-landed'
        }
        let response = await axios.get(
          config.getConfig('serverUrl') + 'sale_page/' + vm.pageid + '/shipping'
        )

        // JSON responses are automatically parsed.
        response = response.data

        if (response) {
          response['cartarray'] = JSON.parse(localStorage.getItem('cartarray'))
          vm.setDetailUsercart(response)
          return true
        } else {
          throw new Error("Can't load salepage user cart")
        }
      } else {
        if (
          ['115414076948160', '396306053873110'].includes(
            this.pageProfile.pageid
          )
        ) {
          //Thailandpostmart
          let cart = this.cart

          if (cart) {
            let total = 0
            cart.forEach((item) => {
              total += parseInt(item.priceBeforeVat)
            })

            let data = {
              // cart_ids: this.pageProfile,
              cartarray: this.cart,
              shippinglist: shippinglist,
              total: total,
              discount: 0,
              totalincludediscount: total,
              promocode: null
            }
            vm.setDetailUsercart(data)
          }
          return true
        } else {
          vm.$store.dispatch('deleteAllItemsInCart')
          let data = {
            shippinglist: shippinglist,
            wholesale_status: vm.pageProfile.wholesale_status
          }
          if (vm.$route.query && vm.$route.query.shoptoken) {
            data.shop_token = vm.$route.query.shoptoken
          }
          let response
          response = await axios.post(
            `${config.getConfig('serverUrl')}v2/usercart`,
            data,
            {
              params: {
                pageid: vm.pageid,
                userid: vm.userid
              }
            }
          )
          response = response.data
          await this.$nextTick()
          if (response.responsecode == 200) {
            vm.setDetailUsercart(response.result)
          } else if (response.responsecode == 400) {
            if (
              response.reason === 'ONLY_ONE_ITEM_CAN_BE_PURCAHSED' ||
              response.reason === 'CAN_BUY_ONLY_1_ORDER_PER_DAY'
            ) {
              response.reason = 'only_one_item_can_be_purcahsed'
            }
            await vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t(response.reason),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('Cancel'),
              showConfirmButton: false,
              reverseButtons: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false
            })
            throw new Error("Can't load user cart")
          } else {
            throw new Error("Can't load user cart")
          }

          return true
        }
      }
    },

    handleSetWeight(cart) {
      this.weight = cart
        ? cart.reduce((prev, curr) => {
            const w =
              curr.optionDetail &&
              curr.optionDetail.length > 8 &&
              curr.optionDetail[8]
                ? curr.optionDetail[8] || 0
                : curr.weight || 0
            prev += w * curr.quantity

            return prev
          }, 0)
        : 0
    },
    setDetailUsercart(response) {
      const vm = this
      vm.weightAll = 0
      let data = response
      vm.$store.commit('SET_CART_ID', data.cart_ids || [])
      if (data.cartarray && data.cartarray.length !== 0) {
        vm.isEmptyShoppingCart = false
        var product_id_list = []
        var products = []

        if (vm.pageProfile.type == 'nvbb') {
          var product = data.cartarray.find(function (val) {
            if (val.option)
              return val.option.toLowerCase().indexOf('other-') != -1
            else return false
          })
          if (product) vm.hasOtherProduct = true
        }
        products = data.cartarray.map(function (val) {
          product_id_list.push(val.productid || val.id)
          var option = null
          var productIndex = vm.allproducts.findIndex((el) => {
            return el.id == val.productid || el.id == val.id
          })
          if (productIndex != -1) {
            var stock = vm.allproducts[productIndex].productstock
            option = stock.find(function (el) {
              if (['khaiwhan', 'gaigao'].includes(vm.pageProfile.type)) {
                if (val.option != 'Normal') {
                  return el[1] == val.option.split(' - ')[0]
                } else {
                  return el[1] == 'Normal'
                }
              } else {
                return el[1] == val.option
              }
            })
          }
          return {
            ...val,
            id: val.productid || val.id,
            price: parseFloat(val.price),
            discountprice: parseFloat(val.discountprice),
            optionDetail: option
          }
        })

        if (vm.pageProfile.pageid === '100619629025288') {
          products.map((item) => {
            var w = 0
            item.optionDetail === null
              ? (w = item.weight)
              : (w =
                  item.optionDetail[8] == null
                    ? item.weight
                    : item.optionDetail[8])
            vm.weightAll += JSON.parse(item.weight)
            vm.weight += JSON.parse(w * item.quantity)
          })
        }

        if (
          vm.hasCartarray &&
          ((vm.getSalePage && vm.getSalePage.is_active) || !vm.userid)
        ) {
          const cart = JSON.parse(localStorage.getItem('cartarray'))
          vm.handleSetWeight(cart)

          var bundleprice = null
          var total_quantity = 0
          total_quantity = cart.reduce(
            (prev, curr) => prev + parseInt(curr.quantity),
            0
          )
          vm.quantityType = total_quantity
          cart.map((item) => {
            let prodprice_total = 0
            if (
              vm.$store.state.pageProfile.wholesale_status &&
              vm.$store.state.wholesale &&
              vm.$store.state.wholesale.length > 0
            ) {
              let wholesale = vm.$store.state.wholesale.find(function (bundle) {
                return (
                  bundle.maxquantity >= total_quantity &&
                  total_quantity >= bundle.minquantity
                )
              })
              if (wholesale) {
                try {
                  prodprice_total = parseFloat(wholesale.price)
                } catch (error) {
                  // eslint-disable-next-line no-console
                  console.error(error)
                }
                bundleprice += prodprice_total * item.quantity
              } else {
                bundleprice += item.bundleprice
              }
            } else {
              if (
                item.productbundle.length !== 0 &&
                !vm.$store.state.pageProfile.wholesale_status
              ) {
                let bundle = item.productbundle.find((p) => {
                  if (
                    item.quantity >= p.minquantity &&
                    item.quantity <= p.maxquantity
                  ) {
                    return true
                  }
                  return false
                })
                if (bundle) {
                  bundleprice += bundle.price * item.quantity
                } else {
                  bundleprice += item.bundleprice
                }
              } else {
                bundleprice += item.bundleprice
              }
            }
          })
          vm.additionalproduct_charge = parseFloat(
            data.shippinglist.additionalproduct_charge[0]
          )
          var price = bundleprice
          vm.ems_charge = parseFloat(data.shippinglist.ems_charge[0])
          vm.normal_charge = parseFloat(data.shippinglist.normal_charge[0])
          vm.kerry_charge = parseFloat(data.shippinglist.kerry_charge[0])
          vm.total = price
          vm.totalincludediscount = price
          // eslint-disable-next-line no-undef
          vm.shippinglist = _.cloneDeep(vm.pageProfile.shippinglist)
        } else {
          vm.additionalproduct_charge = parseFloat(
            data.additionalproduct_charge
          )
          vm.ems_charge = parseFloat(data.ems_charge)
          vm.normal_charge = parseFloat(data.normal_charge)
          vm.kerry_charge = parseFloat(data.kerry_charge)
          vm.total = parseFloat(data.total)
          vm.totalincludediscount = parseFloat(data.totalincludediscount)
          vm.discount = parseFloat(data.discount)
          vm.shippinglist = []

          // eslint-disable-next-line no-undef
          vm.shippinglist = _.cloneDeep(data.shippinglist)

          if (vm.pageProfile.type == 'nvbb') {
            // eslint-disable-next-line no-undef
            vm.nvbbshippinglist = _.cloneDeep(data.shippinglist)
            delete vm.nvbbshippinglist['other_charge']
          }

          vm.handleSetWeight(data.cartarray)
        }

        if (data.promocode) {
          vm.voucherCode = data.promocode
        }

        if (products.length > 0) {
          vm.$store.commit('SET_ALL_CART', products)

          let url =
            config.getConfig('serverUrl') +
            'productbundle?productid=' +
            product_id_list.join(',')
          axios.get(url).then((response) => {
            response = response.data
            if (
              response.responsecode == 200 &&
              response.productbundlelist.length > 0
            ) {
              vm.$store.commit('UPDATE_BUNDLE_CART', response.productbundlelist)
            }
          })
        }
      } else {
        vm.isEmptyShoppingCart = true
      }
      if (vm.$route.query.orderid) {
        vm.isEmptyShoppingCart = false
        vm.getUserOrderInfo()
      }
    },

    async getUserOrderInfo() {
      const vm = this
      let url =
        config.getConfig('serverUrl') +
        `order/${vm.pageid}/get-user-order?userid=${vm.userid}&sessiontoken=${vm.sessiontoken}&orderid=${vm.$route.query.orderid}`
      await axios.get(url).then((response) => {
        response = response.data
        if (response.responsecode == 200) {
          // vm.loading = false
          vm.product_detail_json = response.result
          if (response.result.status === 'shipped') {
            vm.isEmptyShoppingCart = false
          }

          if (response.result.shop_addon_value_json) {
            const shopAddonValueJson = JSON.parse(
              response.result.shop_addon_value_json
            )
            vm.shopOption = shopAddonValueJson
          }

          if (
            vm.pageProfile.is_allow_user_edit_order ||
            (vm.product_detail_json &&
              vm.product_detail_json.created_by.includes('admin'))
          ) {
            vm.isEditAddress = true
          }
          if (vm.product_detail_json && vm.product_detail_json.address_json) {
            const tax = JSON.parse(vm.product_detail_json.address_json)
            if (tax) {
              vm.tax_id = tax.tax_id
              vm.tax_name = tax.tax_name
              vm.taxAddress = tax.tax_address
              if (vm.tax_id) {
                vm.dialogtaxInvoice = true
              }
            }
          }
        }
      })
    },

    goToShop: function () {
      let vm = this
      let url
      if (
        vm.hasCartarray &&
        ((vm.getSalePage && vm.getSalePage.is_active) || !vm.userid)
      ) {
        url = '/salepage/' + vm.pagename
      } else {
        url = '/ecommerce/' + vm.pagename
        if (vm.userid && vm.userid != null && vm.userid != '') {
          url += '?userid=' + vm.userid
          if (
            vm.sessiontoken &&
            vm.sessiontoken != null &&
            vm.sessiontoken != ''
          ) {
            url += '&sessiontoken=' + vm.sessiontoken
          }
        }
      }
      vm.$router.push({ path: url })
    },
    getProducts: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }

        if (vm.$store.state.shop_main_pageid && config.env == 'shopcommu') {
          Object.assign(data, {
            shop_main_pageid: vm.$store.state.shop_main_pageid
          })
        }

        axios
          .get(config.getConfig('serverUrl') + 'products', {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.products = {}
              var products = response.productlist.filter((el) => {
                // console.log(el.status);
                return el.status == true
              })

              // var result = vm.formatProducts(products, vm.categories);
              var allresult = vm.formatProducts(products)
              vm.products = allresult.product_by_index

              vm.allproducts = allresult.products

              resolve()
            } else {
              // console.log(response);
              reject()
            }
          })
      })
    },
    setTaxInvoice() {
      const vm = this
      const address = `${vm.customerName} ${vm.shippingAddress2.district} ${vm.shippingAddress2.sub_district} ${vm.shippingAddress2.province} ${vm.shippingAddress2.zipcode}`
      vm.taxAddress = ['lalamove', 'map'].includes(vm.chooseShippingType)
        ? vm.shippingAddress
        : `${vm.shippingAddress} ${address}`
    },

    renderPaypalBtn: function () {
      var vm = this
      var SERVER = config.getConfig('serverUrl')
      var paypalbtn = document.getElementById('paypal-button')

      if (paypalbtn) {
        paypalbtn.remove()
      }
      const paypal_newbtn = document.createElement('div')
      paypal_newbtn.id = 'paypal-button'
      this.$refs['paypal-button-container'].appendChild(paypal_newbtn)
      this.$nextTick(() => {
        var lang = ''
        if (vm.currentLang == 'th') {
          lang = 'th_TH'
        } else if (vm.currentLang == 'la') {
          lang = 'en_LA'
        } else {
          lang = 'en_US'
        }
        vm.$loadScript('https://www.paypalobjects.com/api/checkout.js')
          .then(() => {
            // Script is loaded, do something
            // eslint-disable-next-line no-undef
            paypal.Button.render(
              {
                locale: lang,
                env: vm.environment,

                validate: function (actions) {
                  // console.log("validate");
                  vm.paypal_actions = actions
                  vm.paypal_actions.disable()
                  // console.log("validate", actions);
                  vm.$validator.validate().then((result) => {
                    if (!result) {
                      // do stuff if not valid.
                      vm.paypal_actions.disable()
                      vm.goToErrorInput()
                      return false
                    }
                    vm.paypal_actions.enable()
                  })
                },
                onClick: function () {
                  // console.log("click", actions);
                  if (vm.paypal_actions) {
                    // vm.paypal_actions.disable();
                    // console.log(vm.paypal_actions);
                    vm.$validator.validate().then((result) => {
                      if (!result) {
                        vm.goToErrorInput()
                        // do stuff if not valid.
                        vm.paypal_actions.disable()
                        // console.log("click error");
                        return false
                      }
                      // console.log("click pass");
                      vm.paypal_actions.enable()
                    })
                  }
                },
                payment: function (data, actions) {
                  // console.log("payment", actions);

                  var request = {
                    amount: vm.totalPrice.toFixed(2).toString(),
                    pageid: vm.pageid,
                    userid: vm.userid,
                    paypal_merchantid: vm.pageProfile.paypal_merchantid
                  }
                  request.cart_ids = vm.$store.state.cart_ids || []

                  if (vm.$route.query.from) {
                    request.from = vm.$route.query.from
                  } else {
                    try {
                      var device = vm.$liff.getOS()
                      var version = vm.$liff.getVersion()
                      vm.$liff.ready.then(() => {
                        if (
                          vm.userid.indexOf('__') != -1 &&
                          device &&
                          version &&
                          !vm.$liff.isInClient()
                        ) {
                          data.from = 'livechat'
                        }
                      })
                    } catch (error) {
                      // eslint-disable-next-line
                      console.log(error)
                    }
                  }

                  return actions.request
                    .post(SERVER + 'merchant-api/create-payment/', request)
                    .then(function (res) {
                      return res.id
                    })
                },
                onAuthorize: function (data, actions) {
                  // console.log("onAuthorize", actions);
                  // console.log("ON AUTHORIZED");
                  // console.log(data);
                  // 2. Make a request to your server

                  var request = {
                    ...vm.formatOrderRequest(),
                    ...vm.extraOrderRequest()
                  }
                  // console.log(request);

                  request.paymentID = data.paymentID
                  request.payerID = data.payerID
                  request.paypal_merchantid = vm.pageProfile.paypal_merchantid
                  if (vm.$store.state.cds.includes(vm.pageid))
                    request.remark = 'หมายเลขเดอะวัน:' + vm.remark
                  if (vm.$route.query.from) {
                    request.from = vm.$route.query.from
                  } else {
                    try {
                      var device = vm.$liff.getOS()
                      var version = vm.$liff.getVersion()
                      vm.$liff.ready.then(() => {
                        if (
                          vm.userid.indexOf('__') != -1 &&
                          device &&
                          version &&
                          !vm.$liff.isInClient()
                        ) {
                          data.from = 'livechat'
                        }
                      })
                    } catch (error) {
                      // eslint-disable-next-line
                      console.log(error)
                    }
                  }
                  if (
                    vm.product_detail_json &&
                    vm.product_detail_json.created_by.includes('admin') &&
                    vm.$route.query &&
                    vm.$route.query.orderid
                  ) {
                    request.orderid = vm.$route.query.orderid
                  }

                  return actions.request
                    .post(SERVER + 'merchant-api/execute-payment/', request)
                    .then(function () {
                      vm.isCompleted = true
                      vm.$store.dispatch('deleteAllItemsInCart')
                      // eslint-disable-next-line
                      if (vm.$liff.isInClient()) {
                        // eslint-disable-next-line no-undef
                        vm.$liff.closeWindow()
                      } else if (vm.$route.query.app == 'facebook') {
                        // eslint-disable-next-line no-undef
                        if (MessengerExtensions) {
                          // eslint-disable-next-line no-undef
                          MessengerExtensions.requestCloseBrowser(
                            function success() {},
                            function error(err) {
                              Sentry.captureException(err)
                              window.close()
                            }
                          )
                        } else {
                          window.close()
                        }
                      } else {
                        if (request.orderid) {
                          vm.$swal({
                            ...vm.getConpleteTransactionText(request.orderid),
                            type: 'success',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            showConfirmButton: true,
                            confirmButtonText: vm.$t('Confirm')
                          }).then((value) => {
                            if (value) {
                              window.close()
                            }
                          })
                        } else {
                          let url = '/ecommerce/' + vm.pagename
                          if (
                            vm.userid &&
                            vm.userid != null &&
                            vm.userid != ''
                          ) {
                            url += '?userid=' + vm.userid
                          }
                          vm.$router.push({ path: url })
                        }
                      }
                    })
                }
              },
              '#paypal-button'
            )
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error)
            // Failed to fetch script
          })
      })
    },

    countDownTimer() {
      clearTimeout(this.timeOutCount)
      if (this.countDown > 0) {
        this.timeOutCount = setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },

    Confirm() {
      const vm = this
      vm.successDialog = false
      vm.isCompleted = true
    },

    async editAddressSubmit() {
      const vm = this
      vm.paymentLoading = true
      vm.loading = true
      if (vm.transferType === 'fbpay') {
        const response = await axios.post(
          `${config.getConfig('serverUrl')}order/${vm.pageid}/${
            vm.$route.query.orderid
          }/generate-fb-pay`
        )
        if (response.status === 200) {
          vm.paymentLoading = false
          vm.loading = false
          if (vm.$liff.isInClient()) {
            // eslint-disable-next-line no-undef
            vm.$liff.closeWindow()
          } else {
            // eslint-disable-next-line no-undef
            if (MessengerExtensions) {
              // eslint-disable-next-line no-undef
              MessengerExtensions.requestCloseBrowser(
                function success() {},
                function error(err) {
                  Sentry.captureException(err)
                  window.close()
                }
              )
            } else {
              window.close()
            }
          }
        }
      } else {
        try {
          const shipping_address_json = {
            name: vm.customerName,
            province: vm.shippingAddress2.province,
            zipcode: vm.shippingAddress2.zipcode,
            district: vm.shippingAddress2.district,
            'sub-district': vm.shippingAddress2.sub_district,
            address: vm.shippingAddress,
            tel: vm.customerPhone
          }
          const data = {
            nameaddress: `${vm.customerName} ,  ${vm.shippingAddress} , ${vm.shippingAddress2.sub_district} , ${vm.shippingAddress2.district} , ${vm.shippingAddress2.province} , ${vm.shippingAddress2.zipcode} , ${vm.customerPhone}`,
            shipping_address_json: JSON.stringify(shipping_address_json),
            shop_addon_value_json: JSON.stringify(vm.shopOption),
            address_json:
              vm.tax_id === ''
                ? JSON.stringify({
                    tax_id: null,
                    tax_address: vm.taxAddress,
                    tax_name: vm.tax_name
                  })
                : JSON.stringify({
                    tax_id: vm.tax_id,
                    tax_address: vm.taxAddress,
                    tax_name: vm.tax_name
                  })
          }
          if (vm.paymentSlipImage) {
            data.note = vm.paymentSlipImage
          }
          if (
            vm.verifyDataEditPage &&
            vm.verifyDataEditPage.eventClick === 'select'
          ) {
            data.note = vm.product_detail_json.note
          }
          if (vm.verifyDataEditPage && vm.verifyDataEditPage.verify_slip_ref) {
            data.note = vm.product_detail_json.note
            data.verify_slip_bank_code =
              vm.verifyDataEditPage.verify_slip_bank_code
            data.verify_slip_ref = vm.verifyDataEditPage.verify_slip_ref
          }

          const response = await axios.put(
            `${config.getConfig('serverUrl')}order/${
              vm.pageid
            }/update-user-order?userid=${vm.userid}&sessiontoken=${
              vm.sessiontoken
            }&orderid=${vm.$route.query.orderid}`,
            data,
            {
              params: {},
              headers: {
                'api-key': '1-2-3-sharks-landed'
              }
            }
          )
          if (response) {
            if (response.status === 200) {
              vm.loading = false
              vm.paymentLoading = true
              vm.$swal({
                ...vm.getConpleteTransactionText(),
                text: vm.$t('edit_address_successful'),
                type: 'success',
                confirmButtonText: vm.$t('Confirm'),
                reverseButtons: true
              }).then((value) => {
                if (value) {
                  window.close()
                  vm.$liff.closeWindow()
                }
              })
            }
          }
        } catch (error) {
          vm.paymentLoading = false
          vm.loading = false
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }
    },

    extraOrderRequest() {
      var data = []
      var gmapregex =
        // eslint-disable-next-line no-useless-escape
        /https\:\/\/www\.google\.com\/maps\?\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
      var shippingAddress
      if (this.chooseShippingType == 'pickup') {
        data.shippingtype = 'pickup_charge'
        data.nameaddress = `${this.customerName} , ${this.customerPhone}`
        data.shipping_address = {
          ...data.shipping_address,
          province: '',
          zipcode: '',
          district: '',
          'sub-district': '',
          address: ''
        }
      } else if (['lalamove', 'map'].includes(this.chooseShippingType)) {
        if (this.shippingAddress) {
          if (gmapregex.test(this.shippingAddress)) {
            this.shippingAddress = this.shippingAddress
              .replace(gmapregex, '')
              .replace('\n', '')
          }
          var ggmap_link = `https://www.google.com/maps?q=${this.gmapvalue.lat.toString()},${this.gmapvalue.lng.toString()}`

          shippingAddress = `${this.shippingAddress}\n${ggmap_link}`
          data.nameaddress = `${this.customerName} , ${shippingAddress} , ${this.customerPhone}`
          data.shipping_address = {
            ...data.shipping_address,
            address: this.shippingAddress,
            ggmap_link: ggmap_link
          }
          if (this.pageProfile.type == 'cityfresh')
            data.shippingtype = 'lalamove_charge'
          else data.shippingtype = 'googlemap_charge'
        }
      }

      // purelife customize end

      return data
    },
    handleCloseWindow() {
      const vm = this
      try {
        if (vm.$liff.isInClient()) {
          vm.$liff.closeWindow()
        } else {
          window.location.href = `https://m.me/${vm.pageProfile.pageid}`
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    async getShippingAddressList() {
      const vm = this
      vm.selectedAddress = null
      try {
        const url = `${config.getConfig('serverUrl')}api/tremendous/liff/${
          vm.pageid
        }/shipping-address/${vm.userid}`
        const resposne = await axios.get(url, {
          headers: { AUTHORIZATION: 'Bearer xxxx xxx' }
        })

        if (resposne && resposne.status === 200) {
          vm.shippingAddressList = resposne.data.data

          if (vm.shippingAddressList) {
            const findMainAddress = vm.shippingAddressList.find((el) => {
              return el.main_address
            })
            vm.selectedAddress = findMainAddress ? findMainAddress.id : null
          }
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    },
    handleSaveAddress() {
      this.getShippingAddressList()

      this.selectedEditAddress = null
      this.shippingFormType = 'add'
      this.showAddressManage = false
    },
    handleEditAddress(item) {
      this.selectedEditAddress = item
      this.showAddressManage = true
      this.shippingFormType = 'edit'
    },
    async handleDeleteAddress(id) {
      const vm = this
      try {
        const result = await vm.$swal({
          text: 'คุณต้องการลบที่อยู่จัดส่งนี้หรือไม่',
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('Cancel'),
          showCancelButton: true,
          reverseButtons: true
        })

        if (result.value) {
          const response = await vm.deleteAddress(id)

          if (response && response.status === 200) {
            vm.getShippingAddressList()
          }
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    },
    async deleteAddress(id) {
      const vm = this
      try {
        const pageId = vm.pageProfile.pageid
        const url = `${config.getConfig(
          'serverUrl'
        )}api/tremendous/liff/${pageId}/shipping-address/${id}`
        const resposne = await axios.delete(url, {
          headers: { AUTHORIZATION: 'Bearer xxxx xxx' }
        })

        if (resposne) {
          return resposne
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    },
    formattedCombineAddress(address) {
      try {
        if (address) {
          const shippingAddress = address.address
          let combineAddress = shippingAddress
            ? shippingAddress.replace(/,/g, '')
            : ''

          if (
            address.sub_district &&
            address.district &&
            address.province &&
            address.zipcode
          ) {
            const inBangkok = address.province == 'กรุงเทพมหานคร'
            combineAddress = combineAddress.replace(address.zipcode, '')
            combineAddress =
              combineAddress +
              ' , ' +
              [
                (inBangkok ? 'แขวง' : 'ตำบล') +
                  address.sub_district.replace(/,/g, ''),
                (inBangkok ? 'เขต' : 'อำเภอ') +
                  address.district.replace(/,/g, ''),
                'จังหวัด' + address.province.replace(/,/g, ''),
                address.zipcode.replace(/,/g, '')
              ].join(' , ')
          }

          return combineAddress
        } else {
          return null
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
        return null
      }
    },
    async handleGetPaymentGateway() {
      try {
        const response = await paymentGatewayApi.getPaymentGateway({
          config: {
            params: {
              page_id: this.pageid,
              is_used: true
            }
          }
        })
        if (response && response.status === 200) {
          this.$store.commit('setPaymentGateways', response.data.data || [])
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    }
  }
}
